export const datosEditadosSimulados = {
    "servicioId": 58,
    "tipoEscenario": "transacciones",
    "nombreEscenarioSeleccionado": "Escenario Transacciones Entrantes - Servicio_Tarificador",
    "horas_x_fte_semanal": 48,
    "objetivoRQ": 95,
    "objetivoEficiencia": 95,
    "nivel_servicio": 85,
    "umbral_nds": 20,
    "planDiaModelo": [
        {
            "id": 5900,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:00:00",
            "intervalo_fin": "07:30:00",
            "volumen": 19,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 6,
            "programados": 7,
            "diferencia": 1
        },
        {
            "id": 5901,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:30:00",
            "intervalo_fin": "08:00:00",
            "volumen": 27,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 8,
            "programados": 9,
            "diferencia": 1
        },
        {
            "id": 5902,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:00:00",
            "intervalo_fin": "08:30:00",
            "volumen": 36,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 10,
            "programados": 11,
            "diferencia": 1
        },
        {
            "id": 5903,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:30:00",
            "intervalo_fin": "09:00:00",
            "volumen": 52,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 13,
            "programados": 15,
            "diferencia": 2
        },
        {
            "id": 5904,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:00:00",
            "intervalo_fin": "09:30:00",
            "volumen": 65,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 16,
            "programados": 18,
            "diferencia": 2
        },
        {
            "id": 5905,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:30:00",
            "intervalo_fin": "10:00:00",
            "volumen": 78,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 19,
            "programados": 22,
            "diferencia": 3
        },
        {
            "id": 5906,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:00:00",
            "intervalo_fin": "10:30:00",
            "volumen": 88,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 5907,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:30:00",
            "intervalo_fin": "11:00:00",
            "volumen": 100,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5908,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:00:00",
            "intervalo_fin": "11:30:00",
            "volumen": 105,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5909,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:30:00",
            "intervalo_fin": "12:00:00",
            "volumen": 112,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5910,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:00:00",
            "intervalo_fin": "12:30:00",
            "volumen": 113,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 26,
            "programados": 29,
            "diferencia": 3
        },
        {
            "id": 5911,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:30:00",
            "intervalo_fin": "13:00:00",
            "volumen": 114,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 26,
            "programados": 29,
            "diferencia": 3
        },
        {
            "id": 5912,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:00:00",
            "intervalo_fin": "13:30:00",
            "volumen": 113,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 26,
            "programados": 29,
            "diferencia": 3
        },
        {
            "id": 5913,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:30:00",
            "intervalo_fin": "14:00:00",
            "volumen": 113,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 26,
            "programados": 29,
            "diferencia": 3
        },
        {
            "id": 5914,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:00:00",
            "intervalo_fin": "14:30:00",
            "volumen": 109,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5915,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:30:00",
            "intervalo_fin": "15:00:00",
            "volumen": 110,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5916,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:00:00",
            "intervalo_fin": "15:30:00",
            "volumen": 107,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5917,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:30:00",
            "intervalo_fin": "16:00:00",
            "volumen": 109,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5918,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:00:00",
            "intervalo_fin": "16:30:00",
            "volumen": 111,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5919,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:30:00",
            "intervalo_fin": "17:00:00",
            "volumen": 112,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5920,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:00:00",
            "intervalo_fin": "17:30:00",
            "volumen": 115,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 26,
            "programados": 29,
            "diferencia": 3
        },
        {
            "id": 5921,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:30:00",
            "intervalo_fin": "18:00:00",
            "volumen": 117,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 26,
            "programados": 29,
            "diferencia": 3
        },
        {
            "id": 5922,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:00:00",
            "intervalo_fin": "18:30:00",
            "volumen": 118,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 27,
            "programados": 31,
            "diferencia": 4
        },
        {
            "id": 5923,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:30:00",
            "intervalo_fin": "19:00:00",
            "volumen": 117,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 26,
            "programados": 29,
            "diferencia": 3
        },
        {
            "id": 5924,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:00:00",
            "intervalo_fin": "19:30:00",
            "volumen": 114,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 26,
            "programados": 29,
            "diferencia": 3
        },
        {
            "id": 5925,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:30:00",
            "intervalo_fin": "20:00:00",
            "volumen": 103,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5926,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:00:00",
            "intervalo_fin": "20:30:00",
            "volumen": 90,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 5927,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:30:00",
            "intervalo_fin": "21:00:00",
            "volumen": 72,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 5928,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:00:00",
            "intervalo_fin": "21:30:00",
            "volumen": 56,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 14,
            "programados": 16,
            "diferencia": 2
        },
        {
            "id": 5929,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:30:00",
            "intervalo_fin": "22:00:00",
            "volumen": 42,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 11,
            "programados": 12,
            "diferencia": 1
        },
        {
            "id": 5930,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:00:00",
            "intervalo_fin": "22:30:00",
            "volumen": 31,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 9,
            "programados": 10,
            "diferencia": 1
        },
        {
            "id": 5931,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:30:00",
            "intervalo_fin": "23:00:00",
            "volumen": 25,
            "dia_semana": "Lunes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 8,
            "programados": 9,
            "diferencia": 1
        },
        {
            "id": 5932,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:00:00",
            "intervalo_fin": "07:30:00",
            "volumen": 17,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 6,
            "programados": 7,
            "diferencia": 1
        },
        {
            "id": 5933,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:30:00",
            "intervalo_fin": "08:00:00",
            "volumen": 25,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 8,
            "programados": 9,
            "diferencia": 1
        },
        {
            "id": 5934,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:00:00",
            "intervalo_fin": "08:30:00",
            "volumen": 34,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 10,
            "programados": 11,
            "diferencia": 1
        },
        {
            "id": 5935,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:30:00",
            "intervalo_fin": "09:00:00",
            "volumen": 48,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 13,
            "programados": 15,
            "diferencia": 2
        },
        {
            "id": 5936,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:00:00",
            "intervalo_fin": "09:30:00",
            "volumen": 60,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 15,
            "programados": 17,
            "diferencia": 2
        },
        {
            "id": 5937,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:30:00",
            "intervalo_fin": "10:00:00",
            "volumen": 72,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 5938,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:00:00",
            "intervalo_fin": "10:30:00",
            "volumen": 82,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 20,
            "programados": 23,
            "diferencia": 3
        },
        {
            "id": 5939,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:30:00",
            "intervalo_fin": "11:00:00",
            "volumen": 92,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 5940,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:00:00",
            "intervalo_fin": "11:30:00",
            "volumen": 97,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5941,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:30:00",
            "intervalo_fin": "12:00:00",
            "volumen": 104,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5942,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:00:00",
            "intervalo_fin": "12:30:00",
            "volumen": 105,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5943,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:30:00",
            "intervalo_fin": "13:00:00",
            "volumen": 106,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5944,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:00:00",
            "intervalo_fin": "13:30:00",
            "volumen": 105,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5945,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:30:00",
            "intervalo_fin": "14:00:00",
            "volumen": 104,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5946,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:00:00",
            "intervalo_fin": "14:30:00",
            "volumen": 101,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5947,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:30:00",
            "intervalo_fin": "15:00:00",
            "volumen": 102,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5948,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:00:00",
            "intervalo_fin": "15:30:00",
            "volumen": 99,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5949,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:30:00",
            "intervalo_fin": "16:00:00",
            "volumen": 101,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5950,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:00:00",
            "intervalo_fin": "16:30:00",
            "volumen": 103,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5951,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:30:00",
            "intervalo_fin": "17:00:00",
            "volumen": 104,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5952,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:00:00",
            "intervalo_fin": "17:30:00",
            "volumen": 107,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5953,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:30:00",
            "intervalo_fin": "18:00:00",
            "volumen": 109,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5954,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:00:00",
            "intervalo_fin": "18:30:00",
            "volumen": 109,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5955,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:30:00",
            "intervalo_fin": "19:00:00",
            "volumen": 108,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5956,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:00:00",
            "intervalo_fin": "19:30:00",
            "volumen": 106,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5957,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:30:00",
            "intervalo_fin": "20:00:00",
            "volumen": 95,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 5958,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:00:00",
            "intervalo_fin": "20:30:00",
            "volumen": 84,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 20,
            "programados": 23,
            "diferencia": 3
        },
        {
            "id": 5959,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:30:00",
            "intervalo_fin": "21:00:00",
            "volumen": 67,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 5960,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:00:00",
            "intervalo_fin": "21:30:00",
            "volumen": 52,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 13,
            "programados": 15,
            "diferencia": 2
        },
        {
            "id": 5961,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:30:00",
            "intervalo_fin": "22:00:00",
            "volumen": 39,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 11,
            "programados": 12,
            "diferencia": 1
        },
        {
            "id": 5962,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:00:00",
            "intervalo_fin": "22:30:00",
            "volumen": 29,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 9,
            "programados": 10,
            "diferencia": 1
        },
        {
            "id": 5963,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:30:00",
            "intervalo_fin": "23:00:00",
            "volumen": 23,
            "dia_semana": "Martes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 5964,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:00:00",
            "intervalo_fin": "07:30:00",
            "volumen": 17,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 6,
            "programados": 7,
            "diferencia": 1
        },
        {
            "id": 5965,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:30:00",
            "intervalo_fin": "08:00:00",
            "volumen": 25,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 8,
            "programados": 9,
            "diferencia": 1
        },
        {
            "id": 5966,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:00:00",
            "intervalo_fin": "08:30:00",
            "volumen": 34,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 10,
            "programados": 11,
            "diferencia": 1
        },
        {
            "id": 5967,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:30:00",
            "intervalo_fin": "09:00:00",
            "volumen": 48,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 13,
            "programados": 15,
            "diferencia": 2
        },
        {
            "id": 5968,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:00:00",
            "intervalo_fin": "09:30:00",
            "volumen": 60,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 15,
            "programados": 17,
            "diferencia": 2
        },
        {
            "id": 5969,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:30:00",
            "intervalo_fin": "10:00:00",
            "volumen": 73,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 5970,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:00:00",
            "intervalo_fin": "10:30:00",
            "volumen": 82,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 20,
            "programados": 23,
            "diferencia": 3
        },
        {
            "id": 5971,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:30:00",
            "intervalo_fin": "11:00:00",
            "volumen": 92,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 5972,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:00:00",
            "intervalo_fin": "11:30:00",
            "volumen": 97,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5973,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:30:00",
            "intervalo_fin": "12:00:00",
            "volumen": 104,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5974,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:00:00",
            "intervalo_fin": "12:30:00",
            "volumen": 105,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5975,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:30:00",
            "intervalo_fin": "13:00:00",
            "volumen": 106,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5976,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:00:00",
            "intervalo_fin": "13:30:00",
            "volumen": 105,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5977,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:30:00",
            "intervalo_fin": "14:00:00",
            "volumen": 105,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5978,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:00:00",
            "intervalo_fin": "14:30:00",
            "volumen": 101,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5979,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:30:00",
            "intervalo_fin": "15:00:00",
            "volumen": 102,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5980,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:00:00",
            "intervalo_fin": "15:30:00",
            "volumen": 100,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5981,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:30:00",
            "intervalo_fin": "16:00:00",
            "volumen": 101,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 5982,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:00:00",
            "intervalo_fin": "16:30:00",
            "volumen": 103,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5983,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:30:00",
            "intervalo_fin": "17:00:00",
            "volumen": 104,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5984,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:00:00",
            "intervalo_fin": "17:30:00",
            "volumen": 107,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5985,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:30:00",
            "intervalo_fin": "18:00:00",
            "volumen": 109,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5986,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:00:00",
            "intervalo_fin": "18:30:00",
            "volumen": 109,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5987,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:30:00",
            "intervalo_fin": "19:00:00",
            "volumen": 108,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 25,
            "programados": 28,
            "diferencia": 3
        },
        {
            "id": 5988,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:00:00",
            "intervalo_fin": "19:30:00",
            "volumen": 106,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 5989,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:30:00",
            "intervalo_fin": "20:00:00",
            "volumen": 95,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 5990,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:00:00",
            "intervalo_fin": "20:30:00",
            "volumen": 84,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 20,
            "programados": 23,
            "diferencia": 3
        },
        {
            "id": 5991,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:30:00",
            "intervalo_fin": "21:00:00",
            "volumen": 67,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 5992,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:00:00",
            "intervalo_fin": "21:30:00",
            "volumen": 52,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 13,
            "programados": 15,
            "diferencia": 2
        },
        {
            "id": 5993,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:30:00",
            "intervalo_fin": "22:00:00",
            "volumen": 39,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 11,
            "programados": 12,
            "diferencia": 1
        },
        {
            "id": 5994,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:00:00",
            "intervalo_fin": "22:30:00",
            "volumen": 29,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 9,
            "programados": 10,
            "diferencia": 1
        },
        {
            "id": 5995,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:30:00",
            "intervalo_fin": "23:00:00",
            "volumen": 24,
            "dia_semana": "Miércoles",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 5996,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:00:00",
            "intervalo_fin": "07:30:00",
            "volumen": 17,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 6,
            "programados": 7,
            "diferencia": 1
        },
        {
            "id": 5997,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:30:00",
            "intervalo_fin": "08:00:00",
            "volumen": 24,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 5998,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:00:00",
            "intervalo_fin": "08:30:00",
            "volumen": 33,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 9,
            "programados": 10,
            "diferencia": 1
        },
        {
            "id": 5999,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:30:00",
            "intervalo_fin": "09:00:00",
            "volumen": 47,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 12,
            "programados": 14,
            "diferencia": 2
        },
        {
            "id": 6000,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:00:00",
            "intervalo_fin": "09:30:00",
            "volumen": 59,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 15,
            "programados": 17,
            "diferencia": 2
        },
        {
            "id": 6001,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:30:00",
            "intervalo_fin": "10:00:00",
            "volumen": 71,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 6002,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:00:00",
            "intervalo_fin": "10:30:00",
            "volumen": 80,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 19,
            "programados": 22,
            "diferencia": 3
        },
        {
            "id": 6003,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:30:00",
            "intervalo_fin": "11:00:00",
            "volumen": 90,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6004,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:00:00",
            "intervalo_fin": "11:30:00",
            "volumen": 95,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6005,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:30:00",
            "intervalo_fin": "12:00:00",
            "volumen": 101,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6006,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:00:00",
            "intervalo_fin": "12:30:00",
            "volumen": 103,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 6007,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:30:00",
            "intervalo_fin": "13:00:00",
            "volumen": 103,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 6008,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:00:00",
            "intervalo_fin": "13:30:00",
            "volumen": 102,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6009,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:30:00",
            "intervalo_fin": "14:00:00",
            "volumen": 102,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6010,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:00:00",
            "intervalo_fin": "14:30:00",
            "volumen": 99,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6011,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:30:00",
            "intervalo_fin": "15:00:00",
            "volumen": 100,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6012,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:00:00",
            "intervalo_fin": "15:30:00",
            "volumen": 97,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6013,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:30:00",
            "intervalo_fin": "16:00:00",
            "volumen": 98,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6014,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:00:00",
            "intervalo_fin": "16:30:00",
            "volumen": 101,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6015,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:30:00",
            "intervalo_fin": "17:00:00",
            "volumen": 102,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6016,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:00:00",
            "intervalo_fin": "17:30:00",
            "volumen": 104,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 6017,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:30:00",
            "intervalo_fin": "18:00:00",
            "volumen": 106,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 6018,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:00:00",
            "intervalo_fin": "18:30:00",
            "volumen": 107,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 6019,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:30:00",
            "intervalo_fin": "19:00:00",
            "volumen": 106,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 6020,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:00:00",
            "intervalo_fin": "19:30:00",
            "volumen": 103,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 24,
            "programados": 27,
            "diferencia": 3
        },
        {
            "id": 6021,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:30:00",
            "intervalo_fin": "20:00:00",
            "volumen": 93,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6022,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:00:00",
            "intervalo_fin": "20:30:00",
            "volumen": 82,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 20,
            "programados": 23,
            "diferencia": 3
        },
        {
            "id": 6023,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:30:00",
            "intervalo_fin": "21:00:00",
            "volumen": 66,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 16,
            "programados": 18,
            "diferencia": 2
        },
        {
            "id": 6024,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:00:00",
            "intervalo_fin": "21:30:00",
            "volumen": 50,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 13,
            "programados": 15,
            "diferencia": 2
        },
        {
            "id": 6025,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:30:00",
            "intervalo_fin": "22:00:00",
            "volumen": 38,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 11,
            "programados": 12,
            "diferencia": 1
        },
        {
            "id": 6026,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:00:00",
            "intervalo_fin": "22:30:00",
            "volumen": 28,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 8,
            "programados": 9,
            "diferencia": 1
        },
        {
            "id": 6027,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:30:00",
            "intervalo_fin": "23:00:00",
            "volumen": 23,
            "dia_semana": "Jueves",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 6028,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:00:00",
            "intervalo_fin": "07:30:00",
            "volumen": 16,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 6,
            "programados": 7,
            "diferencia": 1
        },
        {
            "id": 6029,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:30:00",
            "intervalo_fin": "08:00:00",
            "volumen": 23,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 6030,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:00:00",
            "intervalo_fin": "08:30:00",
            "volumen": 31,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 9,
            "programados": 10,
            "diferencia": 1
        },
        {
            "id": 6031,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:30:00",
            "intervalo_fin": "09:00:00",
            "volumen": 44,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 12,
            "programados": 14,
            "diferencia": 2
        },
        {
            "id": 6032,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:00:00",
            "intervalo_fin": "09:30:00",
            "volumen": 55,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 14,
            "programados": 16,
            "diferencia": 2
        },
        {
            "id": 6033,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:30:00",
            "intervalo_fin": "10:00:00",
            "volumen": 66,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 16,
            "programados": 18,
            "diferencia": 2
        },
        {
            "id": 6034,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:00:00",
            "intervalo_fin": "10:30:00",
            "volumen": 75,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6035,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:30:00",
            "intervalo_fin": "11:00:00",
            "volumen": 84,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 20,
            "programados": 23,
            "diferencia": 3
        },
        {
            "id": 6036,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:00:00",
            "intervalo_fin": "11:30:00",
            "volumen": 89,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6037,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:30:00",
            "intervalo_fin": "12:00:00",
            "volumen": 95,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6038,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:00:00",
            "intervalo_fin": "12:30:00",
            "volumen": 96,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6039,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:30:00",
            "intervalo_fin": "13:00:00",
            "volumen": 97,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6040,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:00:00",
            "intervalo_fin": "13:30:00",
            "volumen": 96,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6041,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:30:00",
            "intervalo_fin": "14:00:00",
            "volumen": 95,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6042,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:00:00",
            "intervalo_fin": "14:30:00",
            "volumen": 92,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6043,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:30:00",
            "intervalo_fin": "15:00:00",
            "volumen": 93,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6044,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:00:00",
            "intervalo_fin": "15:30:00",
            "volumen": 91,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6045,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:30:00",
            "intervalo_fin": "16:00:00",
            "volumen": 92,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6046,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:00:00",
            "intervalo_fin": "16:30:00",
            "volumen": 94,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6047,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:30:00",
            "intervalo_fin": "17:00:00",
            "volumen": 95,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6048,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:00:00",
            "intervalo_fin": "17:30:00",
            "volumen": 98,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6049,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:30:00",
            "intervalo_fin": "18:00:00",
            "volumen": 99,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6050,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:00:00",
            "intervalo_fin": "18:30:00",
            "volumen": 100,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6051,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:30:00",
            "intervalo_fin": "19:00:00",
            "volumen": 99,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6052,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:00:00",
            "intervalo_fin": "19:30:00",
            "volumen": 97,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 23,
            "programados": 26,
            "diferencia": 3
        },
        {
            "id": 6053,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:30:00",
            "intervalo_fin": "20:00:00",
            "volumen": 87,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6054,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:00:00",
            "intervalo_fin": "20:30:00",
            "volumen": 76,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6055,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:30:00",
            "intervalo_fin": "21:00:00",
            "volumen": 61,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 15,
            "programados": 17,
            "diferencia": 2
        },
        {
            "id": 6056,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:00:00",
            "intervalo_fin": "21:30:00",
            "volumen": 47,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 12,
            "programados": 14,
            "diferencia": 2
        },
        {
            "id": 6057,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:30:00",
            "intervalo_fin": "22:00:00",
            "volumen": 35,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 10,
            "programados": 11,
            "diferencia": 1
        },
        {
            "id": 6058,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:00:00",
            "intervalo_fin": "22:30:00",
            "volumen": 26,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 8,
            "programados": 9,
            "diferencia": 1
        },
        {
            "id": 6059,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:30:00",
            "intervalo_fin": "23:00:00",
            "volumen": 21,
            "dia_semana": "Viernes",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 6060,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:00:00",
            "intervalo_fin": "07:30:00",
            "volumen": 15,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 5,
            "programados": 6,
            "diferencia": 1
        },
        {
            "id": 6061,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:30:00",
            "intervalo_fin": "08:00:00",
            "volumen": 21,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 6062,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:00:00",
            "intervalo_fin": "08:30:00",
            "volumen": 28,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 8,
            "programados": 9,
            "diferencia": 1
        },
        {
            "id": 6063,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:30:00",
            "intervalo_fin": "09:00:00",
            "volumen": 41,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 11,
            "programados": 12,
            "diferencia": 1
        },
        {
            "id": 6064,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:00:00",
            "intervalo_fin": "09:30:00",
            "volumen": 51,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 13,
            "programados": 15,
            "diferencia": 2
        },
        {
            "id": 6065,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:30:00",
            "intervalo_fin": "10:00:00",
            "volumen": 61,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 15,
            "programados": 17,
            "diferencia": 2
        },
        {
            "id": 6066,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:00:00",
            "intervalo_fin": "10:30:00",
            "volumen": 69,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 6067,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:30:00",
            "intervalo_fin": "11:00:00",
            "volumen": 78,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 19,
            "programados": 22,
            "diferencia": 3
        },
        {
            "id": 6068,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:00:00",
            "intervalo_fin": "11:30:00",
            "volumen": 82,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 20,
            "programados": 23,
            "diferencia": 3
        },
        {
            "id": 6069,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:30:00",
            "intervalo_fin": "12:00:00",
            "volumen": 88,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6070,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:00:00",
            "intervalo_fin": "12:30:00",
            "volumen": 89,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6071,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:30:00",
            "intervalo_fin": "13:00:00",
            "volumen": 90,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6072,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:00:00",
            "intervalo_fin": "13:30:00",
            "volumen": 89,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6073,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:30:00",
            "intervalo_fin": "14:00:00",
            "volumen": 89,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6074,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:00:00",
            "intervalo_fin": "14:30:00",
            "volumen": 86,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 20,
            "programados": 23,
            "diferencia": 3
        },
        {
            "id": 6075,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:30:00",
            "intervalo_fin": "15:00:00",
            "volumen": 87,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6076,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:00:00",
            "intervalo_fin": "15:30:00",
            "volumen": 84,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 20,
            "programados": 23,
            "diferencia": 3
        },
        {
            "id": 6077,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:30:00",
            "intervalo_fin": "16:00:00",
            "volumen": 85,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 20,
            "programados": 23,
            "diferencia": 3
        },
        {
            "id": 6078,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:00:00",
            "intervalo_fin": "16:30:00",
            "volumen": 87,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6079,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:30:00",
            "intervalo_fin": "17:00:00",
            "volumen": 88,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6080,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:00:00",
            "intervalo_fin": "17:30:00",
            "volumen": 91,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6081,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:30:00",
            "intervalo_fin": "18:00:00",
            "volumen": 92,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6082,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:00:00",
            "intervalo_fin": "18:30:00",
            "volumen": 93,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6083,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:30:00",
            "intervalo_fin": "19:00:00",
            "volumen": 92,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 22,
            "programados": 25,
            "diferencia": 3
        },
        {
            "id": 6084,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:00:00",
            "intervalo_fin": "19:30:00",
            "volumen": 90,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 21,
            "programados": 24,
            "diferencia": 3
        },
        {
            "id": 6085,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:30:00",
            "intervalo_fin": "20:00:00",
            "volumen": 81,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 19,
            "programados": 22,
            "diferencia": 3
        },
        {
            "id": 6086,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:00:00",
            "intervalo_fin": "20:30:00",
            "volumen": 71,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 6087,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:30:00",
            "intervalo_fin": "21:00:00",
            "volumen": 57,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 14,
            "programados": 16,
            "diferencia": 2
        },
        {
            "id": 6088,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:00:00",
            "intervalo_fin": "21:30:00",
            "volumen": 44,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 12,
            "programados": 14,
            "diferencia": 2
        },
        {
            "id": 6089,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:30:00",
            "intervalo_fin": "22:00:00",
            "volumen": 33,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 9,
            "programados": 10,
            "diferencia": 1
        },
        {
            "id": 6090,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:00:00",
            "intervalo_fin": "22:30:00",
            "volumen": 24,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 6091,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:30:00",
            "intervalo_fin": "23:00:00",
            "volumen": 20,
            "dia_semana": "Sábado",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 6092,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:00:00",
            "intervalo_fin": "07:30:00",
            "volumen": 12,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 5,
            "programados": 6,
            "diferencia": 1
        },
        {
            "id": 6093,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "07:30:00",
            "intervalo_fin": "08:00:00",
            "volumen": 17,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 6,
            "programados": 7,
            "diferencia": 1
        },
        {
            "id": 6094,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:00:00",
            "intervalo_fin": "08:30:00",
            "volumen": 23,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 6095,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "08:30:00",
            "intervalo_fin": "09:00:00",
            "volumen": 33,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 9,
            "programados": 10,
            "diferencia": 1
        },
        {
            "id": 6096,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:00:00",
            "intervalo_fin": "09:30:00",
            "volumen": 42,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 11,
            "programados": 12,
            "diferencia": 1
        },
        {
            "id": 6097,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "09:30:00",
            "intervalo_fin": "10:00:00",
            "volumen": 50,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 13,
            "programados": 15,
            "diferencia": 2
        },
        {
            "id": 6098,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:00:00",
            "intervalo_fin": "10:30:00",
            "volumen": 56,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 14,
            "programados": 16,
            "diferencia": 2
        },
        {
            "id": 6099,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "10:30:00",
            "intervalo_fin": "11:00:00",
            "volumen": 64,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 16,
            "programados": 18,
            "diferencia": 2
        },
        {
            "id": 6100,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:00:00",
            "intervalo_fin": "11:30:00",
            "volumen": 67,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 6101,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "11:30:00",
            "intervalo_fin": "12:00:00",
            "volumen": 72,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6102,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:00:00",
            "intervalo_fin": "12:30:00",
            "volumen": 73,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6103,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "12:30:00",
            "intervalo_fin": "13:00:00",
            "volumen": 73,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6104,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:00:00",
            "intervalo_fin": "13:30:00",
            "volumen": 72,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6105,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "13:30:00",
            "intervalo_fin": "14:00:00",
            "volumen": 72,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6106,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:00:00",
            "intervalo_fin": "14:30:00",
            "volumen": 70,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 6107,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "14:30:00",
            "intervalo_fin": "15:00:00",
            "volumen": 71,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 6108,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:00:00",
            "intervalo_fin": "15:30:00",
            "volumen": 69,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 6109,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "15:30:00",
            "intervalo_fin": "16:00:00",
            "volumen": 70,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 6110,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:00:00",
            "intervalo_fin": "16:30:00",
            "volumen": 71,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 17,
            "programados": 19,
            "diferencia": 2
        },
        {
            "id": 6111,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "16:30:00",
            "intervalo_fin": "17:00:00",
            "volumen": 72,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6112,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:00:00",
            "intervalo_fin": "17:30:00",
            "volumen": 74,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6113,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "17:30:00",
            "intervalo_fin": "18:00:00",
            "volumen": 75,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6114,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:00:00",
            "intervalo_fin": "18:30:00",
            "volumen": 75,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6115,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "18:30:00",
            "intervalo_fin": "19:00:00",
            "volumen": 75,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6116,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:00:00",
            "intervalo_fin": "19:30:00",
            "volumen": 73,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 18,
            "programados": 20,
            "diferencia": 2
        },
        {
            "id": 6117,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "19:30:00",
            "intervalo_fin": "20:00:00",
            "volumen": 66,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 16,
            "programados": 18,
            "diferencia": 2
        },
        {
            "id": 6118,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:00:00",
            "intervalo_fin": "20:30:00",
            "volumen": 58,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 15,
            "programados": 17,
            "diferencia": 2
        },
        {
            "id": 6119,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "20:30:00",
            "intervalo_fin": "21:00:00",
            "volumen": 46,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 12,
            "programados": 14,
            "diferencia": 2
        },
        {
            "id": 6120,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:00:00",
            "intervalo_fin": "21:30:00",
            "volumen": 36,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 10,
            "programados": 11,
            "diferencia": 1
        },
        {
            "id": 6121,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "21:30:00",
            "intervalo_fin": "22:00:00",
            "volumen": 27,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 8,
            "programados": 9,
            "diferencia": 1
        },
        {
            "id": 6122,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:00:00",
            "intervalo_fin": "22:30:00",
            "volumen": 20,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 7,
            "programados": 8,
            "diferencia": 1
        },
        {
            "id": 6123,
            "servicio_id": 58,
            "tipo": "transacciones",
            "intervalo_inicio": "22:30:00",
            "intervalo_fin": "23:00:00",
            "volumen": 16,
            "dia_semana": "Domingo",
            "nombre": "Escenario Transacciones Entrantes - Servicio_Tarificador",
            "tmg": 320,
            "requeridos": 6,
            "programados": 7,
            "diferencia": 1
        }
    ],
    "nivelOptimizacion": 0.8,
    "resumenMaximos": [
        {
            "turno": "07:00:00 - 13:00:00",
            "requerido": 8
        },
        {
            "turno": "08:00:00 - 14:00:00",
            "requerido": 6
        },
        {
            "turno": "09:00:00 - 15:00:00",
            "requerido": 8
        },
        {
            "turno": "10:00:00 - 16:00:00",
            "requerido": 6
        },
        {
            "turno": "11:00:00 - 17:00:00",
            "requerido": 5
        },
        {
            "turno": "12:00:00 - 18:00:00",
            "requerido": 1
        },
        {
            "turno": "13:00:00 - 19:00:00",
            "requerido": 3
        },
        {
            "turno": "14:00:00 - 20:00:00",
            "requerido": 6
        },
        {
            "turno": "15:00:00 - 21:00:00",
            "requerido": 8
        },
        {
            "turno": "16:00:00 - 22:00:00",
            "requerido": 6
        },
        {
            "turno": "17:00:00 - 23:00:00",
            "requerido": 9
        }
    ],
    "programacionSemanal": {
        "Agente01": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente02": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente03": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente04": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente05": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente06": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente07": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente08": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente09": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "08:00:00-14:00:00"
        },
        "Agente10": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "08:00:00-14:00:00"
        },
        "Agente11": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "08:00:00-14:00:00"
        },
        "Agente12": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "08:00:00-14:00:00"
        },
        "Agente13": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "08:00:00-14:00:00"
        },
        "Agente14": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "08:00:00-14:00:00"
        },
        "Agente15": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente16": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente17": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente18": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente19": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente20": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente21": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente22": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente23": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "10:00:00-16:00:00"
        },
        "Agente24": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "10:00:00-16:00:00"
        },
        "Agente25": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "10:00:00-16:00:00"
        },
        "Agente26": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "10:00:00-16:00:00"
        },
        "Agente27": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "10:00:00-16:00:00"
        },
        "Agente28": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "10:00:00-16:00:00"
        },
        "Agente29": {
            "Lunes": "11:00:00-17:00:00",
            "Martes": "11:00:00-17:00:00",
            "Miércoles": "11:00:00-17:00:00",
            "Jueves": "11:00:00-17:00:00",
            "Viernes": "11:00:00-17:00:00",
            "Sábado": "11:00:00-17:00:00",
            "Domingo": "11:00:00-17:00:00"
        },
        "Agente30": {
            "Lunes": "11:00:00-17:00:00",
            "Martes": "11:00:00-17:00:00",
            "Miércoles": "11:00:00-17:00:00",
            "Jueves": "11:00:00-17:00:00",
            "Viernes": "11:00:00-17:00:00",
            "Sábado": "11:00:00-17:00:00",
            "Domingo": "11:00:00-17:00:00"
        },
        "Agente31": {
            "Lunes": "11:00:00-17:00:00",
            "Martes": "11:00:00-17:00:00",
            "Miércoles": "11:00:00-17:00:00",
            "Jueves": "11:00:00-17:00:00",
            "Viernes": "11:00:00-17:00:00",
            "Sábado": "11:00:00-17:00:00",
            "Domingo": "11:00:00-17:00:00"
        },
        "Agente32": {
            "Lunes": "11:00:00-17:00:00",
            "Martes": "11:00:00-17:00:00",
            "Miércoles": "11:00:00-17:00:00",
            "Jueves": "11:00:00-17:00:00",
            "Viernes": "11:00:00-17:00:00",
            "Sábado": "11:00:00-17:00:00",
            "Domingo": "11:00:00-17:00:00"
        },
        "Agente33": {
            "Lunes": "11:00:00-17:00:00",
            "Martes": "11:00:00-17:00:00",
            "Miércoles": "11:00:00-17:00:00",
            "Jueves": "11:00:00-17:00:00",
            "Viernes": "11:00:00-17:00:00",
            "Sábado": "11:00:00-17:00:00",
            "Domingo": "11:00:00-17:00:00"
        },
        "Agente34": {
            "Lunes": "12:00:00-18:00:00",
            "Martes": "12:00:00-18:00:00",
            "Miércoles": "12:00:00-18:00:00",
            "Jueves": "12:00:00-18:00:00",
            "Viernes": "12:00:00-18:00:00",
            "Sábado": "12:00:00-18:00:00",
            "Domingo": "12:00:00-18:00:00"
        },
        "Agente35": {
            "Lunes": "13:00:00-19:00:00",
            "Martes": "13:00:00-19:00:00",
            "Miércoles": "13:00:00-19:00:00",
            "Jueves": "13:00:00-19:00:00",
            "Viernes": "13:00:00-19:00:00",
            "Sábado": "13:00:00-19:00:00",
            "Domingo": "13:00:00-19:00:00"
        },
        "Agente36": {
            "Lunes": "13:00:00-19:00:00",
            "Martes": "13:00:00-19:00:00",
            "Miércoles": "13:00:00-19:00:00",
            "Jueves": "13:00:00-19:00:00",
            "Viernes": "13:00:00-19:00:00",
            "Sábado": "13:00:00-19:00:00",
            "Domingo": "13:00:00-19:00:00"
        },
        "Agente37": {
            "Lunes": "13:00:00-19:00:00",
            "Martes": "13:00:00-19:00:00",
            "Miércoles": "13:00:00-19:00:00",
            "Jueves": "13:00:00-19:00:00",
            "Viernes": "13:00:00-19:00:00",
            "Sábado": "13:00:00-19:00:00",
            "Domingo": "13:00:00-19:00:00"
        },
        "Agente38": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "14:00:00-20:00:00",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "14:00:00-20:00:00"
        },
        "Agente39": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "14:00:00-20:00:00",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "14:00:00-20:00:00"
        },
        "Agente40": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "14:00:00-20:00:00",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "14:00:00-20:00:00"
        },
        "Agente41": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "14:00:00-20:00:00",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "14:00:00-20:00:00"
        },
        "Agente42": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "14:00:00-20:00:00",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "14:00:00-20:00:00"
        },
        "Agente43": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "14:00:00-20:00:00",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "14:00:00-20:00:00"
        },
        "Agente44": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente45": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente46": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente47": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente48": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente49": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente50": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente51": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente52": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "16:00:00-22:00:00"
        },
        "Agente53": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "16:00:00-22:00:00"
        },
        "Agente54": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "16:00:00-22:00:00"
        },
        "Agente55": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "16:00:00-22:00:00"
        },
        "Agente56": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "16:00:00-22:00:00"
        },
        "Agente57": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "16:00:00-22:00:00"
        },
        "Agente58": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente59": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente60": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente61": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente62": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente63": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente64": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente65": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente66": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        }
    },
    "detallesPorAgente": [
        {
            "nombre": "Agente01",
            "dia": "Lunes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente02",
            "dia": "Lunes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente03",
            "dia": "Lunes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente04",
            "dia": "Lunes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente05",
            "dia": "Lunes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente06",
            "dia": "Lunes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente07",
            "dia": "Lunes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente08",
            "dia": "Lunes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente01",
            "dia": "Martes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente02",
            "dia": "Martes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente03",
            "dia": "Martes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente04",
            "dia": "Martes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente05",
            "dia": "Martes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente06",
            "dia": "Martes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente07",
            "dia": "Martes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente08",
            "dia": "Martes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente01",
            "dia": "Miércoles",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente02",
            "dia": "Miércoles",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente03",
            "dia": "Miércoles",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente04",
            "dia": "Miércoles",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente05",
            "dia": "Miércoles",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente06",
            "dia": "Miércoles",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente07",
            "dia": "Miércoles",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente08",
            "dia": "Miércoles",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente01",
            "dia": "Jueves",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente02",
            "dia": "Jueves",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente03",
            "dia": "Jueves",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente04",
            "dia": "Jueves",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente05",
            "dia": "Jueves",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente06",
            "dia": "Jueves",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente07",
            "dia": "Jueves",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente08",
            "dia": "Jueves",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente01",
            "dia": "Viernes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente02",
            "dia": "Viernes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente03",
            "dia": "Viernes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente04",
            "dia": "Viernes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente05",
            "dia": "Viernes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente06",
            "dia": "Viernes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente07",
            "dia": "Viernes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente08",
            "dia": "Viernes",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente01",
            "dia": "Sábado",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente02",
            "dia": "Sábado",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente03",
            "dia": "Sábado",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente04",
            "dia": "Sábado",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente05",
            "dia": "Sábado",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente06",
            "dia": "Sábado",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente07",
            "dia": "Sábado",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente08",
            "dia": "Sábado",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente01",
            "dia": "Domingo",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente02",
            "dia": "Domingo",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente03",
            "dia": "Domingo",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente04",
            "dia": "Domingo",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente05",
            "dia": "Domingo",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente06",
            "dia": "Domingo",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente07",
            "dia": "Domingo",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente08",
            "dia": "Domingo",
            "horario": "07:00:00-13:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente09",
            "dia": "Lunes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente10",
            "dia": "Lunes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente11",
            "dia": "Lunes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente12",
            "dia": "Lunes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente13",
            "dia": "Lunes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente14",
            "dia": "Lunes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente09",
            "dia": "Martes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente10",
            "dia": "Martes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente11",
            "dia": "Martes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente12",
            "dia": "Martes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente13",
            "dia": "Martes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente14",
            "dia": "Martes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente09",
            "dia": "Miércoles",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente10",
            "dia": "Miércoles",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente11",
            "dia": "Miércoles",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente12",
            "dia": "Miércoles",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente13",
            "dia": "Miércoles",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente14",
            "dia": "Miércoles",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente09",
            "dia": "Jueves",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente10",
            "dia": "Jueves",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente11",
            "dia": "Jueves",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente12",
            "dia": "Jueves",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente13",
            "dia": "Jueves",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente14",
            "dia": "Jueves",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente09",
            "dia": "Viernes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente10",
            "dia": "Viernes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente11",
            "dia": "Viernes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente12",
            "dia": "Viernes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente13",
            "dia": "Viernes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente14",
            "dia": "Viernes",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente09",
            "dia": "Sábado",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente10",
            "dia": "Sábado",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente11",
            "dia": "Sábado",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente12",
            "dia": "Sábado",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente13",
            "dia": "Sábado",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente14",
            "dia": "Sábado",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente09",
            "dia": "Domingo",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente10",
            "dia": "Domingo",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente11",
            "dia": "Domingo",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente12",
            "dia": "Domingo",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente13",
            "dia": "Domingo",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente14",
            "dia": "Domingo",
            "horario": "08:00:00-14:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente15",
            "dia": "Lunes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente16",
            "dia": "Lunes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente17",
            "dia": "Lunes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente18",
            "dia": "Lunes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente19",
            "dia": "Lunes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente20",
            "dia": "Lunes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente21",
            "dia": "Lunes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente22",
            "dia": "Lunes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente15",
            "dia": "Martes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente16",
            "dia": "Martes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente17",
            "dia": "Martes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente18",
            "dia": "Martes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente19",
            "dia": "Martes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente20",
            "dia": "Martes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente21",
            "dia": "Martes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente22",
            "dia": "Martes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente15",
            "dia": "Miércoles",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente16",
            "dia": "Miércoles",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente17",
            "dia": "Miércoles",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente18",
            "dia": "Miércoles",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente19",
            "dia": "Miércoles",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente20",
            "dia": "Miércoles",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente21",
            "dia": "Miércoles",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente22",
            "dia": "Miércoles",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente15",
            "dia": "Jueves",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente16",
            "dia": "Jueves",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente17",
            "dia": "Jueves",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente18",
            "dia": "Jueves",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente19",
            "dia": "Jueves",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente20",
            "dia": "Jueves",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente21",
            "dia": "Jueves",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente22",
            "dia": "Jueves",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente15",
            "dia": "Viernes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente16",
            "dia": "Viernes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente17",
            "dia": "Viernes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente18",
            "dia": "Viernes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente19",
            "dia": "Viernes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente20",
            "dia": "Viernes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente21",
            "dia": "Viernes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente22",
            "dia": "Viernes",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente15",
            "dia": "Sábado",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente16",
            "dia": "Sábado",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente17",
            "dia": "Sábado",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente18",
            "dia": "Sábado",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente19",
            "dia": "Sábado",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente20",
            "dia": "Sábado",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente21",
            "dia": "Sábado",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente22",
            "dia": "Sábado",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente15",
            "dia": "Domingo",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente16",
            "dia": "Domingo",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente17",
            "dia": "Domingo",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente18",
            "dia": "Domingo",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente19",
            "dia": "Domingo",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente20",
            "dia": "Domingo",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente21",
            "dia": "Domingo",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente22",
            "dia": "Domingo",
            "horario": "09:00:00-15:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente23",
            "dia": "Lunes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente24",
            "dia": "Lunes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente25",
            "dia": "Lunes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente26",
            "dia": "Lunes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente27",
            "dia": "Lunes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente28",
            "dia": "Lunes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente23",
            "dia": "Martes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente24",
            "dia": "Martes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente25",
            "dia": "Martes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente26",
            "dia": "Martes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente27",
            "dia": "Martes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente28",
            "dia": "Martes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente23",
            "dia": "Miércoles",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente24",
            "dia": "Miércoles",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente25",
            "dia": "Miércoles",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente26",
            "dia": "Miércoles",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente27",
            "dia": "Miércoles",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente28",
            "dia": "Miércoles",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente23",
            "dia": "Jueves",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente24",
            "dia": "Jueves",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente25",
            "dia": "Jueves",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente26",
            "dia": "Jueves",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente27",
            "dia": "Jueves",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente28",
            "dia": "Jueves",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente23",
            "dia": "Viernes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente24",
            "dia": "Viernes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente25",
            "dia": "Viernes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente26",
            "dia": "Viernes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente27",
            "dia": "Viernes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente28",
            "dia": "Viernes",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente23",
            "dia": "Sábado",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente24",
            "dia": "Sábado",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente25",
            "dia": "Sábado",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente26",
            "dia": "Sábado",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente27",
            "dia": "Sábado",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente28",
            "dia": "Sábado",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente23",
            "dia": "Domingo",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente24",
            "dia": "Domingo",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente25",
            "dia": "Domingo",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente26",
            "dia": "Domingo",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente27",
            "dia": "Domingo",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente28",
            "dia": "Domingo",
            "horario": "10:00:00-16:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente29",
            "dia": "Lunes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente30",
            "dia": "Lunes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente31",
            "dia": "Lunes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente32",
            "dia": "Lunes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente33",
            "dia": "Lunes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente29",
            "dia": "Martes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente30",
            "dia": "Martes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente31",
            "dia": "Martes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente32",
            "dia": "Martes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente33",
            "dia": "Martes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente29",
            "dia": "Miércoles",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente30",
            "dia": "Miércoles",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente31",
            "dia": "Miércoles",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente32",
            "dia": "Miércoles",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente33",
            "dia": "Miércoles",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente29",
            "dia": "Jueves",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente30",
            "dia": "Jueves",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente31",
            "dia": "Jueves",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente32",
            "dia": "Jueves",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente33",
            "dia": "Jueves",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente29",
            "dia": "Viernes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente30",
            "dia": "Viernes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente31",
            "dia": "Viernes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente32",
            "dia": "Viernes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente33",
            "dia": "Viernes",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente29",
            "dia": "Sábado",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente30",
            "dia": "Sábado",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente31",
            "dia": "Sábado",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente32",
            "dia": "Sábado",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente33",
            "dia": "Sábado",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente29",
            "dia": "Domingo",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente30",
            "dia": "Domingo",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente31",
            "dia": "Domingo",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente32",
            "dia": "Domingo",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente33",
            "dia": "Domingo",
            "horario": "11:00:00-17:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente34",
            "dia": "Lunes",
            "horario": "12:00:00-18:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente34",
            "dia": "Martes",
            "horario": "12:00:00-18:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente34",
            "dia": "Miércoles",
            "horario": "12:00:00-18:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente34",
            "dia": "Jueves",
            "horario": "12:00:00-18:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente34",
            "dia": "Viernes",
            "horario": "12:00:00-18:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente34",
            "dia": "Sábado",
            "horario": "12:00:00-18:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente34",
            "dia": "Domingo",
            "horario": "12:00:00-18:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente35",
            "dia": "Lunes",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente36",
            "dia": "Lunes",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente37",
            "dia": "Lunes",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente35",
            "dia": "Martes",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente36",
            "dia": "Martes",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente37",
            "dia": "Martes",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente35",
            "dia": "Miércoles",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente36",
            "dia": "Miércoles",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente37",
            "dia": "Miércoles",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente35",
            "dia": "Jueves",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente36",
            "dia": "Jueves",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente37",
            "dia": "Jueves",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente35",
            "dia": "Viernes",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente36",
            "dia": "Viernes",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente37",
            "dia": "Viernes",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente35",
            "dia": "Sábado",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente36",
            "dia": "Sábado",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente37",
            "dia": "Sábado",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente35",
            "dia": "Domingo",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente36",
            "dia": "Domingo",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente37",
            "dia": "Domingo",
            "horario": "13:00:00-19:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente38",
            "dia": "Lunes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente39",
            "dia": "Lunes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente40",
            "dia": "Lunes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente41",
            "dia": "Lunes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente42",
            "dia": "Lunes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente43",
            "dia": "Lunes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente38",
            "dia": "Martes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente39",
            "dia": "Martes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente40",
            "dia": "Martes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente41",
            "dia": "Martes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente42",
            "dia": "Martes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente43",
            "dia": "Martes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente38",
            "dia": "Miércoles",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente39",
            "dia": "Miércoles",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente40",
            "dia": "Miércoles",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente41",
            "dia": "Miércoles",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente42",
            "dia": "Miércoles",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente43",
            "dia": "Miércoles",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente38",
            "dia": "Jueves",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente39",
            "dia": "Jueves",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente40",
            "dia": "Jueves",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente41",
            "dia": "Jueves",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente42",
            "dia": "Jueves",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente43",
            "dia": "Jueves",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente38",
            "dia": "Viernes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente39",
            "dia": "Viernes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente40",
            "dia": "Viernes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente41",
            "dia": "Viernes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente42",
            "dia": "Viernes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente43",
            "dia": "Viernes",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente38",
            "dia": "Sábado",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente39",
            "dia": "Sábado",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente40",
            "dia": "Sábado",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente41",
            "dia": "Sábado",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente42",
            "dia": "Sábado",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente43",
            "dia": "Sábado",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente38",
            "dia": "Domingo",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente39",
            "dia": "Domingo",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente40",
            "dia": "Domingo",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente41",
            "dia": "Domingo",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente42",
            "dia": "Domingo",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente43",
            "dia": "Domingo",
            "horario": "14:00:00-20:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente44",
            "dia": "Lunes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente45",
            "dia": "Lunes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente46",
            "dia": "Lunes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente47",
            "dia": "Lunes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente48",
            "dia": "Lunes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente49",
            "dia": "Lunes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente50",
            "dia": "Lunes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente51",
            "dia": "Lunes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente44",
            "dia": "Martes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente45",
            "dia": "Martes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente46",
            "dia": "Martes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente47",
            "dia": "Martes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente48",
            "dia": "Martes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente49",
            "dia": "Martes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente50",
            "dia": "Martes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente51",
            "dia": "Martes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente44",
            "dia": "Miércoles",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente45",
            "dia": "Miércoles",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente46",
            "dia": "Miércoles",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente47",
            "dia": "Miércoles",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente48",
            "dia": "Miércoles",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente49",
            "dia": "Miércoles",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente50",
            "dia": "Miércoles",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente51",
            "dia": "Miércoles",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente44",
            "dia": "Jueves",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente45",
            "dia": "Jueves",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente46",
            "dia": "Jueves",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente47",
            "dia": "Jueves",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente48",
            "dia": "Jueves",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente49",
            "dia": "Jueves",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente50",
            "dia": "Jueves",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente51",
            "dia": "Jueves",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente44",
            "dia": "Viernes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente45",
            "dia": "Viernes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente46",
            "dia": "Viernes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente47",
            "dia": "Viernes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente48",
            "dia": "Viernes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente49",
            "dia": "Viernes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente50",
            "dia": "Viernes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente51",
            "dia": "Viernes",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente44",
            "dia": "Sábado",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente45",
            "dia": "Sábado",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente46",
            "dia": "Sábado",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente47",
            "dia": "Sábado",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente48",
            "dia": "Sábado",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente49",
            "dia": "Sábado",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente50",
            "dia": "Sábado",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente51",
            "dia": "Sábado",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente44",
            "dia": "Domingo",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente45",
            "dia": "Domingo",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente46",
            "dia": "Domingo",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente47",
            "dia": "Domingo",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente48",
            "dia": "Domingo",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente49",
            "dia": "Domingo",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente50",
            "dia": "Domingo",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente51",
            "dia": "Domingo",
            "horario": "15:00:00-21:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente52",
            "dia": "Lunes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente53",
            "dia": "Lunes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente54",
            "dia": "Lunes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente55",
            "dia": "Lunes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente56",
            "dia": "Lunes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente57",
            "dia": "Lunes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente52",
            "dia": "Martes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente53",
            "dia": "Martes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente54",
            "dia": "Martes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente55",
            "dia": "Martes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente56",
            "dia": "Martes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente57",
            "dia": "Martes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente52",
            "dia": "Miércoles",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente53",
            "dia": "Miércoles",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente54",
            "dia": "Miércoles",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente55",
            "dia": "Miércoles",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente56",
            "dia": "Miércoles",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente57",
            "dia": "Miércoles",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente52",
            "dia": "Jueves",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente53",
            "dia": "Jueves",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente54",
            "dia": "Jueves",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente55",
            "dia": "Jueves",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente56",
            "dia": "Jueves",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente57",
            "dia": "Jueves",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente52",
            "dia": "Viernes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente53",
            "dia": "Viernes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente54",
            "dia": "Viernes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente55",
            "dia": "Viernes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente56",
            "dia": "Viernes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente57",
            "dia": "Viernes",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente52",
            "dia": "Sábado",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente53",
            "dia": "Sábado",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente54",
            "dia": "Sábado",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente55",
            "dia": "Sábado",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente56",
            "dia": "Sábado",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente57",
            "dia": "Sábado",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente52",
            "dia": "Domingo",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente53",
            "dia": "Domingo",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente54",
            "dia": "Domingo",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente55",
            "dia": "Domingo",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente56",
            "dia": "Domingo",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente57",
            "dia": "Domingo",
            "horario": "16:00:00-22:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente58",
            "dia": "Lunes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente59",
            "dia": "Lunes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente60",
            "dia": "Lunes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente61",
            "dia": "Lunes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente62",
            "dia": "Lunes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente63",
            "dia": "Lunes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente64",
            "dia": "Lunes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente65",
            "dia": "Lunes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente66",
            "dia": "Lunes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente58",
            "dia": "Martes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente59",
            "dia": "Martes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente60",
            "dia": "Martes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente61",
            "dia": "Martes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente62",
            "dia": "Martes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente63",
            "dia": "Martes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente64",
            "dia": "Martes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente65",
            "dia": "Martes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente66",
            "dia": "Martes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente58",
            "dia": "Miércoles",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente59",
            "dia": "Miércoles",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente60",
            "dia": "Miércoles",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente61",
            "dia": "Miércoles",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente62",
            "dia": "Miércoles",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente63",
            "dia": "Miércoles",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente64",
            "dia": "Miércoles",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente65",
            "dia": "Miércoles",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente66",
            "dia": "Miércoles",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente58",
            "dia": "Jueves",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente59",
            "dia": "Jueves",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente60",
            "dia": "Jueves",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente61",
            "dia": "Jueves",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente62",
            "dia": "Jueves",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente63",
            "dia": "Jueves",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente64",
            "dia": "Jueves",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente65",
            "dia": "Jueves",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente66",
            "dia": "Jueves",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente58",
            "dia": "Viernes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente59",
            "dia": "Viernes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente60",
            "dia": "Viernes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente61",
            "dia": "Viernes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente62",
            "dia": "Viernes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente63",
            "dia": "Viernes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente64",
            "dia": "Viernes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente65",
            "dia": "Viernes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente66",
            "dia": "Viernes",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente58",
            "dia": "Sábado",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente59",
            "dia": "Sábado",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente60",
            "dia": "Sábado",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente61",
            "dia": "Sábado",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente62",
            "dia": "Sábado",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente63",
            "dia": "Sábado",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente64",
            "dia": "Sábado",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente65",
            "dia": "Sábado",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente66",
            "dia": "Sábado",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente58",
            "dia": "Domingo",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente59",
            "dia": "Domingo",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente60",
            "dia": "Domingo",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente61",
            "dia": "Domingo",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente62",
            "dia": "Domingo",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente63",
            "dia": "Domingo",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente64",
            "dia": "Domingo",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente65",
            "dia": "Domingo",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        },
        {
            "nombre": "Agente66",
            "dia": "Domingo",
            "horario": "17:00:00-23:00:00",
            "jornada": 6,
            "recesos": [
                {
                    "tipo": "comida",
                    "duracion": "00:30:00",
                    "jornada_max": "7.9",
                    "jornada_min": "1",
                    "max_antes_fin": "1.50",
                    "min_desde_inicio": "1.50",
                    "max_antes_fin_min": 90,
                    "min_desde_inicio_min": 90
                }
            ]
        }
    ],
    "itemsProgramaSemanal": [
        {
            "id": 1,
            "agente": "Agente01",
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 2,
            "agente": "Agente02",
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 3,
            "agente": "Agente03",
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 4,
            "agente": "Agente04",
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 5,
            "agente": "Agente05",
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 6,
            "agente": "Agente06",
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 7,
            "agente": "Agente07",
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 8,
            "agente": "Agente08",
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 9,
            "agente": "Agente09",
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "08:00:00-14:00:00"
        },
        {
            "id": 10,
            "agente": "Agente10",
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "08:00:00-14:00:00"
        },
        {
            "id": 11,
            "agente": "Agente11",
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "08:00:00-14:00:00"
        },
        {
            "id": 12,
            "agente": "Agente12",
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "08:00:00-14:00:00"
        },
        {
            "id": 13,
            "agente": "Agente13",
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "08:00:00-14:00:00"
        },
        {
            "id": 14,
            "agente": "Agente14",
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "08:00:00-14:00:00"
        },
        {
            "id": 15,
            "agente": "Agente15",
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 16,
            "agente": "Agente16",
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 17,
            "agente": "Agente17",
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 18,
            "agente": "Agente18",
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 19,
            "agente": "Agente19",
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 20,
            "agente": "Agente20",
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 21,
            "agente": "Agente21",
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 22,
            "agente": "Agente22",
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 23,
            "agente": "Agente23",
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "10:00:00-16:00:00",
            "domingo": "10:00:00-16:00:00"
        },
        {
            "id": 24,
            "agente": "Agente24",
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "10:00:00-16:00:00",
            "domingo": "10:00:00-16:00:00"
        },
        {
            "id": 25,
            "agente": "Agente25",
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "10:00:00-16:00:00",
            "domingo": "10:00:00-16:00:00"
        },
        {
            "id": 26,
            "agente": "Agente26",
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "10:00:00-16:00:00",
            "domingo": "10:00:00-16:00:00"
        },
        {
            "id": 27,
            "agente": "Agente27",
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "10:00:00-16:00:00",
            "domingo": "10:00:00-16:00:00"
        },
        {
            "id": 28,
            "agente": "Agente28",
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "10:00:00-16:00:00",
            "domingo": "10:00:00-16:00:00"
        },
        {
            "id": 29,
            "agente": "Agente29",
            "lunes": "11:00:00-17:00:00",
            "martes": "11:00:00-17:00:00",
            "miércoles": "11:00:00-17:00:00",
            "jueves": "11:00:00-17:00:00",
            "viernes": "11:00:00-17:00:00",
            "sábado": "11:00:00-17:00:00",
            "domingo": "11:00:00-17:00:00"
        },
        {
            "id": 30,
            "agente": "Agente30",
            "lunes": "11:00:00-17:00:00",
            "martes": "11:00:00-17:00:00",
            "miércoles": "11:00:00-17:00:00",
            "jueves": "11:00:00-17:00:00",
            "viernes": "11:00:00-17:00:00",
            "sábado": "11:00:00-17:00:00",
            "domingo": "11:00:00-17:00:00"
        },
        {
            "id": 31,
            "agente": "Agente31",
            "lunes": "11:00:00-17:00:00",
            "martes": "11:00:00-17:00:00",
            "miércoles": "11:00:00-17:00:00",
            "jueves": "11:00:00-17:00:00",
            "viernes": "11:00:00-17:00:00",
            "sábado": "11:00:00-17:00:00",
            "domingo": "11:00:00-17:00:00"
        },
        {
            "id": 32,
            "agente": "Agente32",
            "lunes": "11:00:00-17:00:00",
            "martes": "11:00:00-17:00:00",
            "miércoles": "11:00:00-17:00:00",
            "jueves": "11:00:00-17:00:00",
            "viernes": "11:00:00-17:00:00",
            "sábado": "11:00:00-17:00:00",
            "domingo": "11:00:00-17:00:00"
        },
        {
            "id": 33,
            "agente": "Agente33",
            "lunes": "11:00:00-17:00:00",
            "martes": "11:00:00-17:00:00",
            "miércoles": "11:00:00-17:00:00",
            "jueves": "11:00:00-17:00:00",
            "viernes": "11:00:00-17:00:00",
            "sábado": "11:00:00-17:00:00",
            "domingo": "11:00:00-17:00:00"
        },
        {
            "id": 34,
            "agente": "Agente34",
            "lunes": "12:00:00-18:00:00",
            "martes": "12:00:00-18:00:00",
            "miércoles": "12:00:00-18:00:00",
            "jueves": "12:00:00-18:00:00",
            "viernes": "12:00:00-18:00:00",
            "sábado": "12:00:00-18:00:00",
            "domingo": "12:00:00-18:00:00"
        },
        {
            "id": 35,
            "agente": "Agente35",
            "lunes": "13:00:00-19:00:00",
            "martes": "13:00:00-19:00:00",
            "miércoles": "13:00:00-19:00:00",
            "jueves": "13:00:00-19:00:00",
            "viernes": "13:00:00-19:00:00",
            "sábado": "13:00:00-19:00:00",
            "domingo": "13:00:00-19:00:00"
        },
        {
            "id": 36,
            "agente": "Agente36",
            "lunes": "13:00:00-19:00:00",
            "martes": "13:00:00-19:00:00",
            "miércoles": "13:00:00-19:00:00",
            "jueves": "13:00:00-19:00:00",
            "viernes": "13:00:00-19:00:00",
            "sábado": "13:00:00-19:00:00",
            "domingo": "13:00:00-19:00:00"
        },
        {
            "id": 37,
            "agente": "Agente37",
            "lunes": "13:00:00-19:00:00",
            "martes": "13:00:00-19:00:00",
            "miércoles": "13:00:00-19:00:00",
            "jueves": "13:00:00-19:00:00",
            "viernes": "13:00:00-19:00:00",
            "sábado": "13:00:00-19:00:00",
            "domingo": "13:00:00-19:00:00"
        },
        {
            "id": 38,
            "agente": "Agente38",
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "14:00:00-20:00:00",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "14:00:00-20:00:00"
        },
        {
            "id": 39,
            "agente": "Agente39",
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "14:00:00-20:00:00",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "14:00:00-20:00:00"
        },
        {
            "id": 40,
            "agente": "Agente40",
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "14:00:00-20:00:00",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "14:00:00-20:00:00"
        },
        {
            "id": 41,
            "agente": "Agente41",
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "14:00:00-20:00:00",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "14:00:00-20:00:00"
        },
        {
            "id": 42,
            "agente": "Agente42",
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "14:00:00-20:00:00",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "14:00:00-20:00:00"
        },
        {
            "id": 43,
            "agente": "Agente43",
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "14:00:00-20:00:00",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "14:00:00-20:00:00"
        },
        {
            "id": 44,
            "agente": "Agente44",
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 45,
            "agente": "Agente45",
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 46,
            "agente": "Agente46",
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 47,
            "agente": "Agente47",
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 48,
            "agente": "Agente48",
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 49,
            "agente": "Agente49",
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 50,
            "agente": "Agente50",
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 51,
            "agente": "Agente51",
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 52,
            "agente": "Agente52",
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "16:00:00-22:00:00"
        },
        {
            "id": 53,
            "agente": "Agente53",
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "16:00:00-22:00:00"
        },
        {
            "id": 54,
            "agente": "Agente54",
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "16:00:00-22:00:00"
        },
        {
            "id": 55,
            "agente": "Agente55",
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "16:00:00-22:00:00"
        },
        {
            "id": 56,
            "agente": "Agente56",
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "16:00:00-22:00:00"
        },
        {
            "id": 57,
            "agente": "Agente57",
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "16:00:00-22:00:00"
        },
        {
            "id": 58,
            "agente": "Agente58",
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 59,
            "agente": "Agente59",
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 60,
            "agente": "Agente60",
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 61,
            "agente": "Agente61",
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 62,
            "agente": "Agente62",
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 63,
            "agente": "Agente63",
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 64,
            "agente": "Agente64",
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 65,
            "agente": "Agente65",
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 66,
            "agente": "Agente66",
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        }
    ],
    "headersProgramaSemanal": [
        {
            "text": "Agente",
            "value": "agente"
        },
        {
            "text": "Lunes",
            "value": "lunes"
        },
        {
            "text": "Martes",
            "value": "martes"
        },
        {
            "text": "Miércoles",
            "value": "miércoles"
        },
        {
            "text": "Jueves",
            "value": "jueves"
        },
        {
            "text": "Viernes",
            "value": "viernes"
        },
        {
            "text": "Sábado",
            "value": "sábado"
        },
        {
            "text": "Domingo",
            "value": "domingo"
        }
    ],
    "matrizAsignacion": [
        {
            "turno": "07:00:00 - 13:00:00",
            "Lunes": 8,
            "Martes": 8,
            "Miércoles": 8,
            "Jueves": 8,
            "Viernes": 7,
            "Sábado": 7,
            "Domingo": 6
        },
        {
            "turno": "08:00:00 - 14:00:00",
            "Lunes": 6,
            "Martes": 5,
            "Miércoles": 5,
            "Jueves": 5,
            "Viernes": 6,
            "Sábado": 5,
            "Domingo": 4
        },
        {
            "turno": "09:00:00 - 15:00:00",
            "Lunes": 8,
            "Martes": 8,
            "Miércoles": 8,
            "Jueves": 8,
            "Viernes": 6,
            "Sábado": 6,
            "Domingo": 6
        },
        {
            "turno": "10:00:00 - 16:00:00",
            "Lunes": 6,
            "Martes": 5,
            "Miércoles": 5,
            "Jueves": 6,
            "Viernes": 5,
            "Sábado": 5,
            "Domingo": 3
        },
        {
            "turno": "11:00:00 - 17:00:00",
            "Lunes": 3,
            "Martes": 5,
            "Miércoles": 5,
            "Jueves": 4,
            "Viernes": 5,
            "Sábado": 4,
            "Domingo": 3
        },
        {
            "turno": "12:00:00 - 18:00:00",
            "Lunes": 0,
            "Martes": 1,
            "Miércoles": 1,
            "Jueves": 1,
            "Viernes": 0,
            "Sábado": 0,
            "Domingo": 1
        },
        {
            "turno": "13:00:00 - 19:00:00",
            "Lunes": 3,
            "Martes": 2,
            "Miércoles": 2,
            "Jueves": 1,
            "Viernes": 1,
            "Sábado": 2,
            "Domingo": 2
        },
        {
            "turno": "14:00:00 - 20:00:00",
            "Lunes": 5,
            "Martes": 4,
            "Miércoles": 4,
            "Jueves": 4,
            "Viernes": 6,
            "Sábado": 5,
            "Domingo": 3
        },
        {
            "turno": "15:00:00 - 21:00:00",
            "Lunes": 8,
            "Martes": 8,
            "Miércoles": 8,
            "Jueves": 8,
            "Viernes": 6,
            "Sábado": 5,
            "Domingo": 6
        },
        {
            "turno": "16:00:00 - 22:00:00",
            "Lunes": 6,
            "Martes": 5,
            "Miércoles": 5,
            "Jueves": 6,
            "Viernes": 5,
            "Sábado": 6,
            "Domingo": 3
        },
        {
            "turno": "17:00:00 - 23:00:00",
            "Lunes": 9,
            "Martes": 9,
            "Miércoles": 9,
            "Jueves": 8,
            "Viernes": 8,
            "Sábado": 7,
            "Domingo": 7
        }
    ],
    "itemsConDescanso": [
        {
            "id": 1,
            "agente": "Agente01",
            "turnoBase": "07:00:00-13:00:00",
            "colorIndex": 1,
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "DS"
        },
        {
            "id": 2,
            "agente": "Agente02",
            "turnoBase": "07:00:00-13:00:00",
            "colorIndex": 1,
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "DS"
        },
        {
            "id": 3,
            "agente": "Agente03",
            "turnoBase": "07:00:00-13:00:00",
            "colorIndex": 1,
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "DS",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 4,
            "agente": "Agente04",
            "turnoBase": "07:00:00-13:00:00",
            "colorIndex": 1,
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "DS",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 5,
            "agente": "Agente05",
            "turnoBase": "07:00:00-13:00:00",
            "colorIndex": 1,
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "DS"
        },
        {
            "id": 6,
            "agente": "Agente06",
            "turnoBase": "07:00:00-13:00:00",
            "colorIndex": 1,
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "DS",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 7,
            "agente": "Agente07",
            "turnoBase": "07:00:00-13:00:00",
            "colorIndex": 1,
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "07:00:00-13:00:00",
            "viernes": "DS",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 8,
            "agente": "Agente08",
            "turnoBase": "07:00:00-13:00:00",
            "colorIndex": 1,
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "07:00:00-13:00:00",
            "jueves": "DS",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 9,
            "agente": "Agente09",
            "turnoBase": "07:00:00-13:00:00",
            "colorIndex": 1,
            "lunes": "07:00:00-13:00:00",
            "martes": "07:00:00-13:00:00",
            "miércoles": "DS",
            "jueves": "07:00:00-13:00:00",
            "viernes": "07:00:00-13:00:00",
            "sábado": "07:00:00-13:00:00",
            "domingo": "07:00:00-13:00:00"
        },
        {
            "id": 10,
            "agente": "Agente10",
            "turnoBase": "08:00:00-14:00:00",
            "colorIndex": 0,
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "DS"
        },
        {
            "id": 11,
            "agente": "Agente11",
            "turnoBase": "08:00:00-14:00:00",
            "colorIndex": 0,
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "DS"
        },
        {
            "id": 12,
            "agente": "Agente12",
            "turnoBase": "08:00:00-14:00:00",
            "colorIndex": 0,
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "DS",
            "domingo": "08:00:00-14:00:00"
        },
        {
            "id": 13,
            "agente": "Agente13",
            "turnoBase": "08:00:00-14:00:00",
            "colorIndex": 0,
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "DS",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "08:00:00-14:00:00"
        },
        {
            "id": 14,
            "agente": "Agente14",
            "turnoBase": "08:00:00-14:00:00",
            "colorIndex": 0,
            "lunes": "08:00:00-14:00:00",
            "martes": "08:00:00-14:00:00",
            "miércoles": "DS",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "08:00:00-14:00:00"
        },
        {
            "id": 15,
            "agente": "Agente15",
            "turnoBase": "08:00:00-14:00:00",
            "colorIndex": 0,
            "lunes": "08:00:00-14:00:00",
            "martes": "DS",
            "miércoles": "08:00:00-14:00:00",
            "jueves": "08:00:00-14:00:00",
            "viernes": "08:00:00-14:00:00",
            "sábado": "08:00:00-14:00:00",
            "domingo": "08:00:00-14:00:00"
        },
        {
            "id": 16,
            "agente": "Agente16",
            "turnoBase": "09:00:00-15:00:00",
            "colorIndex": 1,
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "DS"
        },
        {
            "id": 17,
            "agente": "Agente17",
            "turnoBase": "09:00:00-15:00:00",
            "colorIndex": 1,
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "DS"
        },
        {
            "id": 18,
            "agente": "Agente18",
            "turnoBase": "09:00:00-15:00:00",
            "colorIndex": 1,
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "DS",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 19,
            "agente": "Agente19",
            "turnoBase": "09:00:00-15:00:00",
            "colorIndex": 1,
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "DS",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 20,
            "agente": "Agente20",
            "turnoBase": "09:00:00-15:00:00",
            "colorIndex": 1,
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "DS",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 21,
            "agente": "Agente21",
            "turnoBase": "09:00:00-15:00:00",
            "colorIndex": 1,
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "DS",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 22,
            "agente": "Agente22",
            "turnoBase": "09:00:00-15:00:00",
            "colorIndex": 1,
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "09:00:00-15:00:00",
            "domingo": "DS"
        },
        {
            "id": 23,
            "agente": "Agente23",
            "turnoBase": "09:00:00-15:00:00",
            "colorIndex": 1,
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "09:00:00-15:00:00",
            "sábado": "DS",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 24,
            "agente": "Agente24",
            "turnoBase": "09:00:00-15:00:00",
            "colorIndex": 1,
            "lunes": "09:00:00-15:00:00",
            "martes": "09:00:00-15:00:00",
            "miércoles": "09:00:00-15:00:00",
            "jueves": "09:00:00-15:00:00",
            "viernes": "DS",
            "sábado": "09:00:00-15:00:00",
            "domingo": "09:00:00-15:00:00"
        },
        {
            "id": 25,
            "agente": "Agente25",
            "turnoBase": "10:00:00-16:00:00",
            "colorIndex": 0,
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "10:00:00-16:00:00",
            "domingo": "DS"
        },
        {
            "id": 26,
            "agente": "Agente26",
            "turnoBase": "10:00:00-16:00:00",
            "colorIndex": 0,
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "10:00:00-16:00:00",
            "domingo": "DS"
        },
        {
            "id": 27,
            "agente": "Agente27",
            "turnoBase": "10:00:00-16:00:00",
            "colorIndex": 0,
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "10:00:00-16:00:00",
            "domingo": "DS"
        },
        {
            "id": 28,
            "agente": "Agente28",
            "turnoBase": "10:00:00-16:00:00",
            "colorIndex": 0,
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "DS",
            "domingo": "10:00:00-16:00:00"
        },
        {
            "id": 29,
            "agente": "Agente29",
            "turnoBase": "10:00:00-16:00:00",
            "colorIndex": 0,
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "10:00:00-16:00:00",
            "jueves": "10:00:00-16:00:00",
            "viernes": "DS",
            "sábado": "10:00:00-16:00:00",
            "domingo": "10:00:00-16:00:00"
        },
        {
            "id": 30,
            "agente": "Agente30",
            "turnoBase": "10:00:00-16:00:00",
            "colorIndex": 0,
            "lunes": "10:00:00-16:00:00",
            "martes": "10:00:00-16:00:00",
            "miércoles": "DS",
            "jueves": "10:00:00-16:00:00",
            "viernes": "10:00:00-16:00:00",
            "sábado": "10:00:00-16:00:00",
            "domingo": "10:00:00-16:00:00"
        },
        {
            "id": 31,
            "agente": "Agente31",
            "turnoBase": "11:00:00-17:00:00",
            "colorIndex": 1,
            "lunes": "11:00:00-17:00:00",
            "martes": "11:00:00-17:00:00",
            "miércoles": "11:00:00-17:00:00",
            "jueves": "11:00:00-17:00:00",
            "viernes": "11:00:00-17:00:00",
            "sábado": "11:00:00-17:00:00",
            "domingo": "DS"
        },
        {
            "id": 32,
            "agente": "Agente32",
            "turnoBase": "11:00:00-17:00:00",
            "colorIndex": 1,
            "lunes": "11:00:00-17:00:00",
            "martes": "11:00:00-17:00:00",
            "miércoles": "11:00:00-17:00:00",
            "jueves": "11:00:00-17:00:00",
            "viernes": "11:00:00-17:00:00",
            "sábado": "11:00:00-17:00:00",
            "domingo": "DS"
        },
        {
            "id": 33,
            "agente": "Agente33",
            "turnoBase": "11:00:00-17:00:00",
            "colorIndex": 1,
            "lunes": "DS",
            "martes": "11:00:00-17:00:00",
            "miércoles": "11:00:00-17:00:00",
            "jueves": "11:00:00-17:00:00",
            "viernes": "11:00:00-17:00:00",
            "sábado": "11:00:00-17:00:00",
            "domingo": "11:00:00-17:00:00"
        },
        {
            "id": 34,
            "agente": "Agente34",
            "turnoBase": "11:00:00-17:00:00",
            "colorIndex": 1,
            "lunes": "DS",
            "martes": "11:00:00-17:00:00",
            "miércoles": "11:00:00-17:00:00",
            "jueves": "11:00:00-17:00:00",
            "viernes": "11:00:00-17:00:00",
            "sábado": "11:00:00-17:00:00",
            "domingo": "11:00:00-17:00:00"
        },
        {
            "id": 35,
            "agente": "Agente35",
            "turnoBase": "11:00:00-17:00:00",
            "colorIndex": 1,
            "lunes": "11:00:00-17:00:00",
            "martes": "11:00:00-17:00:00",
            "miércoles": "11:00:00-17:00:00",
            "jueves": "11:00:00-17:00:00",
            "viernes": "11:00:00-17:00:00",
            "sábado": "DS",
            "domingo": "11:00:00-17:00:00"
        },
        {
            "id": 36,
            "agente": "Agente36",
            "turnoBase": "12:00:00-18:00:00",
            "colorIndex": 0,
            "lunes": "12:00:00-18:00:00",
            "martes": "12:00:00-18:00:00",
            "miércoles": "12:00:00-18:00:00",
            "jueves": "12:00:00-18:00:00",
            "viernes": "12:00:00-18:00:00",
            "sábado": "12:00:00-18:00:00",
            "domingo": "DS"
        },
        {
            "id": 37,
            "agente": "Agente37",
            "turnoBase": "12:00:00-18:00:00",
            "colorIndex": 0,
            "lunes": "12:00:00-18:00:00",
            "martes": "12:00:00-18:00:00",
            "miércoles": "12:00:00-18:00:00",
            "jueves": "DS",
            "viernes": "12:00:00-18:00:00",
            "sábado": "12:00:00-18:00:00",
            "domingo": "12:00:00-18:00:00"
        },
        {
            "id": 38,
            "agente": "Agente38",
            "turnoBase": "13:00:00-19:00:00",
            "colorIndex": 1,
            "lunes": "13:00:00-19:00:00",
            "martes": "13:00:00-19:00:00",
            "miércoles": "13:00:00-19:00:00",
            "jueves": "13:00:00-19:00:00",
            "viernes": "DS",
            "sábado": "13:00:00-19:00:00",
            "domingo": "13:00:00-19:00:00"
        },
        {
            "id": 39,
            "agente": "Agente39",
            "turnoBase": "13:00:00-19:00:00",
            "colorIndex": 1,
            "lunes": "13:00:00-19:00:00",
            "martes": "13:00:00-19:00:00",
            "miércoles": "13:00:00-19:00:00",
            "jueves": "13:00:00-19:00:00",
            "viernes": "DS",
            "sábado": "13:00:00-19:00:00",
            "domingo": "13:00:00-19:00:00"
        },
        {
            "id": 40,
            "agente": "Agente40",
            "turnoBase": "13:00:00-19:00:00",
            "colorIndex": 1,
            "lunes": "13:00:00-19:00:00",
            "martes": "13:00:00-19:00:00",
            "miércoles": "13:00:00-19:00:00",
            "jueves": "DS",
            "viernes": "13:00:00-19:00:00",
            "sábado": "13:00:00-19:00:00",
            "domingo": "13:00:00-19:00:00"
        },
        {
            "id": 41,
            "agente": "Agente41",
            "turnoBase": "14:00:00-20:00:00",
            "colorIndex": 0,
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "14:00:00-20:00:00",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "DS"
        },
        {
            "id": 42,
            "agente": "Agente42",
            "turnoBase": "14:00:00-20:00:00",
            "colorIndex": 0,
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "14:00:00-20:00:00",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "DS"
        },
        {
            "id": 43,
            "agente": "Agente43",
            "turnoBase": "14:00:00-20:00:00",
            "colorIndex": 0,
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "14:00:00-20:00:00",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "DS"
        },
        {
            "id": 44,
            "agente": "Agente44",
            "turnoBase": "14:00:00-20:00:00",
            "colorIndex": 0,
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "DS",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "14:00:00-20:00:00"
        },
        {
            "id": 45,
            "agente": "Agente45",
            "turnoBase": "14:00:00-20:00:00",
            "colorIndex": 0,
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "14:00:00-20:00:00",
            "jueves": "DS",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "14:00:00-20:00:00"
        },
        {
            "id": 46,
            "agente": "Agente46",
            "turnoBase": "14:00:00-20:00:00",
            "colorIndex": 0,
            "lunes": "14:00:00-20:00:00",
            "martes": "14:00:00-20:00:00",
            "miércoles": "DS",
            "jueves": "14:00:00-20:00:00",
            "viernes": "14:00:00-20:00:00",
            "sábado": "14:00:00-20:00:00",
            "domingo": "14:00:00-20:00:00"
        },
        {
            "id": 47,
            "agente": "Agente47",
            "turnoBase": "15:00:00-21:00:00",
            "colorIndex": 1,
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "DS",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 48,
            "agente": "Agente48",
            "turnoBase": "15:00:00-21:00:00",
            "colorIndex": 1,
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "DS",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 49,
            "agente": "Agente49",
            "turnoBase": "15:00:00-21:00:00",
            "colorIndex": 1,
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "DS",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 50,
            "agente": "Agente50",
            "turnoBase": "15:00:00-21:00:00",
            "colorIndex": 1,
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "DS"
        },
        {
            "id": 51,
            "agente": "Agente51",
            "turnoBase": "15:00:00-21:00:00",
            "colorIndex": 1,
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "DS"
        },
        {
            "id": 52,
            "agente": "Agente52",
            "turnoBase": "15:00:00-21:00:00",
            "colorIndex": 1,
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "DS",
            "sábado": "15:00:00-21:00:00",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 53,
            "agente": "Agente53",
            "turnoBase": "15:00:00-21:00:00",
            "colorIndex": 1,
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "DS",
            "sábado": "15:00:00-21:00:00",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 54,
            "agente": "Agente54",
            "turnoBase": "15:00:00-21:00:00",
            "colorIndex": 1,
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "DS",
            "domingo": "15:00:00-21:00:00"
        },
        {
            "id": 55,
            "agente": "Agente55",
            "turnoBase": "15:00:00-21:00:00",
            "colorIndex": 1,
            "lunes": "15:00:00-21:00:00",
            "martes": "15:00:00-21:00:00",
            "miércoles": "15:00:00-21:00:00",
            "jueves": "15:00:00-21:00:00",
            "viernes": "15:00:00-21:00:00",
            "sábado": "15:00:00-21:00:00",
            "domingo": "DS"
        },
        {
            "id": 56,
            "agente": "Agente56",
            "turnoBase": "16:00:00-22:00:00",
            "colorIndex": 0,
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "DS"
        },
        {
            "id": 57,
            "agente": "Agente57",
            "turnoBase": "16:00:00-22:00:00",
            "colorIndex": 0,
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "DS"
        },
        {
            "id": 58,
            "agente": "Agente58",
            "turnoBase": "16:00:00-22:00:00",
            "colorIndex": 0,
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "DS"
        },
        {
            "id": 59,
            "agente": "Agente59",
            "turnoBase": "16:00:00-22:00:00",
            "colorIndex": 0,
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "DS",
            "sábado": "16:00:00-22:00:00",
            "domingo": "16:00:00-22:00:00"
        },
        {
            "id": 60,
            "agente": "Agente60",
            "turnoBase": "16:00:00-22:00:00",
            "colorIndex": 0,
            "lunes": "16:00:00-22:00:00",
            "martes": "16:00:00-22:00:00",
            "miércoles": "DS",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "16:00:00-22:00:00"
        },
        {
            "id": 61,
            "agente": "Agente61",
            "turnoBase": "16:00:00-22:00:00",
            "colorIndex": 0,
            "lunes": "16:00:00-22:00:00",
            "martes": "DS",
            "miércoles": "16:00:00-22:00:00",
            "jueves": "16:00:00-22:00:00",
            "viernes": "16:00:00-22:00:00",
            "sábado": "16:00:00-22:00:00",
            "domingo": "16:00:00-22:00:00"
        },
        {
            "id": 62,
            "agente": "Agente62",
            "turnoBase": "17:00:00-23:00:00",
            "colorIndex": 1,
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "DS"
        },
        {
            "id": 63,
            "agente": "Agente63",
            "turnoBase": "17:00:00-23:00:00",
            "colorIndex": 1,
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "DS"
        },
        {
            "id": 64,
            "agente": "Agente64",
            "turnoBase": "17:00:00-23:00:00",
            "colorIndex": 1,
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "DS",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 65,
            "agente": "Agente65",
            "turnoBase": "17:00:00-23:00:00",
            "colorIndex": 1,
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "DS",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 66,
            "agente": "Agente66",
            "turnoBase": "17:00:00-23:00:00",
            "colorIndex": 1,
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "DS",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 67,
            "agente": "Agente67",
            "turnoBase": "17:00:00-23:00:00",
            "colorIndex": 1,
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "DS",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 68,
            "agente": "Agente68",
            "turnoBase": "17:00:00-23:00:00",
            "colorIndex": 1,
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "DS"
        },
        {
            "id": 69,
            "agente": "Agente69",
            "turnoBase": "17:00:00-23:00:00",
            "colorIndex": 1,
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "17:00:00-23:00:00",
            "sábado": "DS",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 70,
            "agente": "Agente70",
            "turnoBase": "17:00:00-23:00:00",
            "colorIndex": 1,
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "17:00:00-23:00:00",
            "viernes": "DS",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        },
        {
            "id": 71,
            "agente": "Agente71",
            "turnoBase": "17:00:00-23:00:00",
            "colorIndex": 1,
            "lunes": "17:00:00-23:00:00",
            "martes": "17:00:00-23:00:00",
            "miércoles": "17:00:00-23:00:00",
            "jueves": "DS",
            "viernes": "17:00:00-23:00:00",
            "sábado": "17:00:00-23:00:00",
            "domingo": "17:00:00-23:00:00"
        }
    ],
    "headersConDescanso": [
        {
            "text": "Agente",
            "value": "agente"
        },
        {
            "text": "Lunes",
            "value": "lunes"
        },
        {
            "text": "Martes",
            "value": "martes"
        },
        {
            "text": "Miércoles",
            "value": "miércoles"
        },
        {
            "text": "Jueves",
            "value": "jueves"
        },
        {
            "text": "Viernes",
            "value": "viernes"
        },
        {
            "text": "Sábado",
            "value": "sábado"
        },
        {
            "text": "Domingo",
            "value": "domingo"
        }
    ],
    "descansosFinales": [
        {
            "agente": "Agente38",
            "dia": "Lunes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente23",
            "dia": "Jueves",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente29",
            "dia": "Lunes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente19",
            "dia": "Viernes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente23",
            "dia": "Martes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente25",
            "dia": "Miércoles",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente36",
            "dia": "Sábado",
            "bloque": "14:00–14:30",
            "duracion": 30
        },
        {
            "agente": "Agente33",
            "dia": "Miércoles",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente36",
            "dia": "Martes",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente33",
            "dia": "Jueves",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente25",
            "dia": "Sábado",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente31",
            "dia": "Martes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente23",
            "dia": "Viernes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente20",
            "dia": "Domingo",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente27",
            "dia": "Jueves",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente24",
            "dia": "Sábado",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente31",
            "dia": "Lunes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente36",
            "dia": "Jueves",
            "bloque": "13:30–14:00",
            "duracion": 30
        },
        {
            "agente": "Agente19",
            "dia": "Miércoles",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente19",
            "dia": "Domingo",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente11",
            "dia": "Jueves",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente22",
            "dia": "Martes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente01",
            "dia": "Miércoles",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente05",
            "dia": "Viernes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente27",
            "dia": "Lunes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente29",
            "dia": "Martes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente09",
            "dia": "Domingo",
            "bloque": "09:00–09:30",
            "duracion": 30
        },
        {
            "agente": "Agente01",
            "dia": "Martes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente34",
            "dia": "Viernes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente06",
            "dia": "Jueves",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente29",
            "dia": "Domingo",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente08",
            "dia": "Miércoles",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente34",
            "dia": "Domingo",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente04",
            "dia": "Miércoles",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente03",
            "dia": "Miércoles",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente31",
            "dia": "Jueves",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente05",
            "dia": "Martes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente26",
            "dia": "Viernes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente08",
            "dia": "Domingo",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente23",
            "dia": "Lunes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente02",
            "dia": "Miércoles",
            "bloque": "09:00–09:30",
            "duracion": 30
        },
        {
            "agente": "Agente37",
            "dia": "Lunes",
            "bloque": "15:00–15:30",
            "duracion": 30
        },
        {
            "agente": "Agente03",
            "dia": "Martes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente24",
            "dia": "Jueves",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente07",
            "dia": "Sábado",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente08",
            "dia": "Lunes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente52",
            "dia": "Martes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente48",
            "dia": "Lunes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente07",
            "dia": "Martes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente07",
            "dia": "Lunes",
            "bloque": "09:00–09:30",
            "duracion": 30
        },
        {
            "agente": "Agente48",
            "dia": "Miércoles",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente24",
            "dia": "Miércoles",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente06",
            "dia": "Viernes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente64",
            "dia": "Viernes",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente49",
            "dia": "Domingo",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente48",
            "dia": "Domingo",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente24",
            "dia": "Lunes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente25",
            "dia": "Jueves",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente61",
            "dia": "Viernes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente54",
            "dia": "Domingo",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente32",
            "dia": "Lunes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente59",
            "dia": "Sábado",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente54",
            "dia": "Martes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente51",
            "dia": "Lunes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente33",
            "dia": "Sábado",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente09",
            "dia": "Martes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente33",
            "dia": "Domingo",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente30",
            "dia": "Lunes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente20",
            "dia": "Miércoles",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente59",
            "dia": "Lunes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente05",
            "dia": "Lunes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente06",
            "dia": "Domingo",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente05",
            "dia": "Sábado",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente29",
            "dia": "Sábado",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente38",
            "dia": "Domingo",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente21",
            "dia": "Jueves",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente45",
            "dia": "Lunes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente55",
            "dia": "Jueves",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente56",
            "dia": "Miércoles",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente58",
            "dia": "Jueves",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente40",
            "dia": "Martes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente55",
            "dia": "Miércoles",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente61",
            "dia": "Jueves",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente50",
            "dia": "Lunes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente07",
            "dia": "Miércoles",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente35",
            "dia": "Martes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente62",
            "dia": "Miércoles",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente26",
            "dia": "Lunes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente25",
            "dia": "Martes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente07",
            "dia": "Domingo",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente57",
            "dia": "Miércoles",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente08",
            "dia": "Viernes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente31",
            "dia": "Viernes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente04",
            "dia": "Martes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente55",
            "dia": "Viernes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente02",
            "dia": "Viernes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente58",
            "dia": "Miércoles",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente63",
            "dia": "Miércoles",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente51",
            "dia": "Sábado",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente45",
            "dia": "Sábado",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente21",
            "dia": "Domingo",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente39",
            "dia": "Domingo",
            "bloque": "16:00–16:30",
            "duracion": 30
        },
        {
            "agente": "Agente22",
            "dia": "Sábado",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente02",
            "dia": "Martes",
            "bloque": "09:00–09:30",
            "duracion": 30
        },
        {
            "agente": "Agente40",
            "dia": "Miércoles",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente36",
            "dia": "Viernes",
            "bloque": "15:00–15:30",
            "duracion": 30
        },
        {
            "agente": "Agente06",
            "dia": "Miércoles",
            "bloque": "09:00–09:30",
            "duracion": 30
        },
        {
            "agente": "Agente38",
            "dia": "Martes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente46",
            "dia": "Domingo",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente01",
            "dia": "Lunes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente37",
            "dia": "Martes",
            "bloque": "14:30–15:00",
            "duracion": 30
        },
        {
            "agente": "Agente43",
            "dia": "Viernes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente05",
            "dia": "Miércoles",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente62",
            "dia": "Viernes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente32",
            "dia": "Viernes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente40",
            "dia": "Sábado",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente05",
            "dia": "Jueves",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente63",
            "dia": "Martes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente49",
            "dia": "Lunes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente09",
            "dia": "Sábado",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente49",
            "dia": "Miércoles",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente50",
            "dia": "Jueves",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente61",
            "dia": "Lunes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente39",
            "dia": "Martes",
            "bloque": "15:00–15:30",
            "duracion": 30
        },
        {
            "agente": "Agente29",
            "dia": "Miércoles",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente33",
            "dia": "Viernes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente28",
            "dia": "Lunes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente04",
            "dia": "Lunes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente06",
            "dia": "Lunes",
            "bloque": "09:00–09:30",
            "duracion": 30
        },
        {
            "agente": "Agente57",
            "dia": "Sábado",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente37",
            "dia": "Miércoles",
            "bloque": "14:30–15:00",
            "duracion": 30
        },
        {
            "agente": "Agente46",
            "dia": "Lunes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente02",
            "dia": "Sábado",
            "bloque": "09:00–09:30",
            "duracion": 30
        },
        {
            "agente": "Agente58",
            "dia": "Viernes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente46",
            "dia": "Jueves",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente56",
            "dia": "Sábado",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente54",
            "dia": "Viernes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente01",
            "dia": "Jueves",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente41",
            "dia": "Jueves",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente60",
            "dia": "Sábado",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente45",
            "dia": "Domingo",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente34",
            "dia": "Miércoles",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente46",
            "dia": "Sábado",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente42",
            "dia": "Viernes",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente48",
            "dia": "Jueves",
            "bloque": "16:30–17:00",
            "duracion": 30
        },
        {
            "agente": "Agente18",
            "dia": "Viernes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente10",
            "dia": "Sábado",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente53",
            "dia": "Martes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente35",
            "dia": "Domingo",
            "bloque": "13:30–14:00",
            "duracion": 30
        },
        {
            "agente": "Agente32",
            "dia": "Martes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente55",
            "dia": "Martes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente03",
            "dia": "Viernes",
            "bloque": "09:00–09:30",
            "duracion": 30
        },
        {
            "agente": "Agente62",
            "dia": "Lunes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente49",
            "dia": "Jueves",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente40",
            "dia": "Domingo",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente03",
            "dia": "Lunes",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente51",
            "dia": "Martes",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente24",
            "dia": "Domingo",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente64",
            "dia": "Jueves",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente60",
            "dia": "Domingo",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente09",
            "dia": "Lunes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente42",
            "dia": "Lunes",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente14",
            "dia": "Lunes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente43",
            "dia": "Sábado",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente65",
            "dia": "Domingo",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente70",
            "dia": "Martes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente41",
            "dia": "Martes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente47",
            "dia": "Martes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente52",
            "dia": "Lunes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente66",
            "dia": "Jueves",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente69",
            "dia": "Miércoles",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente04",
            "dia": "Domingo",
            "bloque": "09:00–09:30",
            "duracion": 30
        },
        {
            "agente": "Agente42",
            "dia": "Jueves",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente58",
            "dia": "Sábado",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente68",
            "dia": "Jueves",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente43",
            "dia": "Jueves",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente40",
            "dia": "Lunes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente39",
            "dia": "Lunes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente59",
            "dia": "Domingo",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente08",
            "dia": "Martes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente53",
            "dia": "Jueves",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente58",
            "dia": "Martes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente38",
            "dia": "Jueves",
            "bloque": "14:30–15:00",
            "duracion": 30
        },
        {
            "agente": "Agente10",
            "dia": "Jueves",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente52",
            "dia": "Domingo",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente48",
            "dia": "Martes",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente24",
            "dia": "Martes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente57",
            "dia": "Jueves",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente44",
            "dia": "Viernes",
            "bloque": "16:30–17:00",
            "duracion": 30
        },
        {
            "agente": "Agente22",
            "dia": "Jueves",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente53",
            "dia": "Domingo",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente66",
            "dia": "Lunes",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente09",
            "dia": "Jueves",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente03",
            "dia": "Jueves",
            "bloque": "09:00–09:30",
            "duracion": 30
        },
        {
            "agente": "Agente46",
            "dia": "Martes",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente71",
            "dia": "Lunes",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente11",
            "dia": "Lunes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente30",
            "dia": "Jueves",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente49",
            "dia": "Viernes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente31",
            "dia": "Miércoles",
            "bloque": "14:00–14:30",
            "duracion": 30
        },
        {
            "agente": "Agente20",
            "dia": "Martes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente26",
            "dia": "Miércoles",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente38",
            "dia": "Miércoles",
            "bloque": "15:00–15:30",
            "duracion": 30
        },
        {
            "agente": "Agente66",
            "dia": "Miércoles",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente14",
            "dia": "Domingo",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente37",
            "dia": "Domingo",
            "bloque": "14:30–15:00",
            "duracion": 30
        },
        {
            "agente": "Agente63",
            "dia": "Sábado",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente36",
            "dia": "Lunes",
            "bloque": "16:00–16:30",
            "duracion": 30
        },
        {
            "agente": "Agente34",
            "dia": "Martes",
            "bloque": "14:00–14:30",
            "duracion": 30
        },
        {
            "agente": "Agente70",
            "dia": "Jueves",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente21",
            "dia": "Miércoles",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente56",
            "dia": "Lunes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente12",
            "dia": "Miércoles",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente21",
            "dia": "Martes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente47",
            "dia": "Viernes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente27",
            "dia": "Viernes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente01",
            "dia": "Viernes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente16",
            "dia": "Jueves",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente30",
            "dia": "Viernes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente19",
            "dia": "Lunes",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente17",
            "dia": "Viernes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente07",
            "dia": "Jueves",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente53",
            "dia": "Miércoles",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente15",
            "dia": "Jueves",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente10",
            "dia": "Miércoles",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente35",
            "dia": "Lunes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente20",
            "dia": "Sábado",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente18",
            "dia": "Lunes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente04",
            "dia": "Jueves",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente52",
            "dia": "Miércoles",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente09",
            "dia": "Viernes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente71",
            "dia": "Viernes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente12",
            "dia": "Domingo",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente44",
            "dia": "Miércoles",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente70",
            "dia": "Lunes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente37",
            "dia": "Viernes",
            "bloque": "16:00–16:30",
            "duracion": 30
        },
        {
            "agente": "Agente19",
            "dia": "Martes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente28",
            "dia": "Martes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente63",
            "dia": "Viernes",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente02",
            "dia": "Jueves",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente03",
            "dia": "Domingo",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente15",
            "dia": "Miércoles",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente64",
            "dia": "Domingo",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente11",
            "dia": "Martes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente06",
            "dia": "Martes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente55",
            "dia": "Lunes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente12",
            "dia": "Martes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente69",
            "dia": "Domingo",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente67",
            "dia": "Lunes",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente34",
            "dia": "Jueves",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente02",
            "dia": "Lunes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente37",
            "dia": "Sábado",
            "bloque": "14:30–15:00",
            "duracion": 30
        },
        {
            "agente": "Agente13",
            "dia": "Lunes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente28",
            "dia": "Miércoles",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente49",
            "dia": "Martes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente08",
            "dia": "Sábado",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente01",
            "dia": "Sábado",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente13",
            "dia": "Domingo",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente55",
            "dia": "Sábado",
            "bloque": "16:30–17:00",
            "duracion": 30
        },
        {
            "agente": "Agente46",
            "dia": "Viernes",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente18",
            "dia": "Jueves",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente69",
            "dia": "Lunes",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente21",
            "dia": "Lunes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente54",
            "dia": "Miércoles",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente41",
            "dia": "Miércoles",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente41",
            "dia": "Viernes",
            "bloque": "16:00–16:30",
            "duracion": 30
        },
        {
            "agente": "Agente27",
            "dia": "Miércoles",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente19",
            "dia": "Jueves",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente51",
            "dia": "Jueves",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente32",
            "dia": "Jueves",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente17",
            "dia": "Martes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente50",
            "dia": "Miércoles",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente67",
            "dia": "Miércoles",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente57",
            "dia": "Martes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente16",
            "dia": "Lunes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente12",
            "dia": "Jueves",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente04",
            "dia": "Sábado",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente15",
            "dia": "Domingo",
            "bloque": "09:30–10:00",
            "duracion": 30
        },
        {
            "agente": "Agente69",
            "dia": "Viernes",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente18",
            "dia": "Martes",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente69",
            "dia": "Martes",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente42",
            "dia": "Sábado",
            "bloque": "16:00–16:30",
            "duracion": 30
        },
        {
            "agente": "Agente42",
            "dia": "Miércoles",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente36",
            "dia": "Miércoles",
            "bloque": "15:00–15:30",
            "duracion": 30
        },
        {
            "agente": "Agente33",
            "dia": "Martes",
            "bloque": "15:00–15:30",
            "duracion": 30
        },
        {
            "agente": "Agente14",
            "dia": "Sábado",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente34",
            "dia": "Sábado",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente15",
            "dia": "Lunes",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente44",
            "dia": "Domingo",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente11",
            "dia": "Miércoles",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente20",
            "dia": "Lunes",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente68",
            "dia": "Lunes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente52",
            "dia": "Jueves",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente16",
            "dia": "Martes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente43",
            "dia": "Martes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente20",
            "dia": "Jueves",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente25",
            "dia": "Viernes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente15",
            "dia": "Sábado",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente39",
            "dia": "Jueves",
            "bloque": "16:00–16:30",
            "duracion": 30
        },
        {
            "agente": "Agente35",
            "dia": "Viernes",
            "bloque": "15:00–15:30",
            "duracion": 30
        },
        {
            "agente": "Agente16",
            "dia": "Sábado",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente59",
            "dia": "Miércoles",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente58",
            "dia": "Lunes",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente65",
            "dia": "Miércoles",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente16",
            "dia": "Miércoles",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente30",
            "dia": "Martes",
            "bloque": "14:00–14:30",
            "duracion": 30
        },
        {
            "agente": "Agente22",
            "dia": "Miércoles",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente32",
            "dia": "Miércoles",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente62",
            "dia": "Sábado",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente39",
            "dia": "Miércoles",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente60",
            "dia": "Martes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente47",
            "dia": "Domingo",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente35",
            "dia": "Miércoles",
            "bloque": "14:30–15:00",
            "duracion": 30
        },
        {
            "agente": "Agente63",
            "dia": "Jueves",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente31",
            "dia": "Sábado",
            "bloque": "15:00–15:30",
            "duracion": 30
        },
        {
            "agente": "Agente57",
            "dia": "Viernes",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente59",
            "dia": "Martes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente39",
            "dia": "Sábado",
            "bloque": "14:30–15:00",
            "duracion": 30
        },
        {
            "agente": "Agente13",
            "dia": "Martes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente14",
            "dia": "Viernes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente27",
            "dia": "Martes",
            "bloque": "13:30–14:00",
            "duracion": 30
        },
        {
            "agente": "Agente53",
            "dia": "Sábado",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente28",
            "dia": "Viernes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente57",
            "dia": "Lunes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente62",
            "dia": "Jueves",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente56",
            "dia": "Jueves",
            "bloque": "20:00–20:30",
            "duracion": 30
        },
        {
            "agente": "Agente63",
            "dia": "Lunes",
            "bloque": "20:00–20:30",
            "duracion": 30
        },
        {
            "agente": "Agente13",
            "dia": "Miércoles",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente71",
            "dia": "Miércoles",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente59",
            "dia": "Jueves",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente71",
            "dia": "Domingo",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente14",
            "dia": "Jueves",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente16",
            "dia": "Viernes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente12",
            "dia": "Lunes",
            "bloque": "09:30–10:00",
            "duracion": 30
        },
        {
            "agente": "Agente17",
            "dia": "Miércoles",
            "bloque": "13:00–13:30",
            "duracion": 30
        },
        {
            "agente": "Agente30",
            "dia": "Domingo",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente28",
            "dia": "Jueves",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente70",
            "dia": "Miércoles",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente47",
            "dia": "Jueves",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente61",
            "dia": "Miércoles",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente10",
            "dia": "Martes",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente17",
            "dia": "Jueves",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente35",
            "dia": "Jueves",
            "bloque": "13:00–13:30",
            "duracion": 30
        },
        {
            "agente": "Agente44",
            "dia": "Martes",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente26",
            "dia": "Sábado",
            "bloque": "14:00–14:30",
            "duracion": 30
        },
        {
            "agente": "Agente50",
            "dia": "Martes",
            "bloque": "16:30–17:00",
            "duracion": 30
        },
        {
            "agente": "Agente13",
            "dia": "Viernes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente66",
            "dia": "Sábado",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente64",
            "dia": "Lunes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente30",
            "dia": "Sábado",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente27",
            "dia": "Sábado",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente12",
            "dia": "Viernes",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente45",
            "dia": "Martes",
            "bloque": "16:00–16:30",
            "duracion": 30
        },
        {
            "agente": "Agente64",
            "dia": "Martes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente11",
            "dia": "Viernes",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente60",
            "dia": "Jueves",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente67",
            "dia": "Viernes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente56",
            "dia": "Martes",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente10",
            "dia": "Lunes",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente69",
            "dia": "Jueves",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente62",
            "dia": "Martes",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente26",
            "dia": "Jueves",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente56",
            "dia": "Viernes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente45",
            "dia": "Miércoles",
            "bloque": "16:30–17:00",
            "duracion": 30
        },
        {
            "agente": "Agente43",
            "dia": "Miércoles",
            "bloque": "16:00–16:30",
            "duracion": 30
        },
        {
            "agente": "Agente14",
            "dia": "Martes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente17",
            "dia": "Lunes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente23",
            "dia": "Miércoles",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente42",
            "dia": "Martes",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente66",
            "dia": "Martes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente29",
            "dia": "Jueves",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente50",
            "dia": "Sábado",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente61",
            "dia": "Domingo",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente54",
            "dia": "Lunes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente10",
            "dia": "Viernes",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente18",
            "dia": "Miércoles",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente28",
            "dia": "Domingo",
            "bloque": "14:00–14:30",
            "duracion": 30
        },
        {
            "agente": "Agente22",
            "dia": "Lunes",
            "bloque": "11:00–11:30",
            "duracion": 30
        },
        {
            "agente": "Agente67",
            "dia": "Sábado",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente65",
            "dia": "Viernes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente51",
            "dia": "Viernes",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente65",
            "dia": "Martes",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente25",
            "dia": "Lunes",
            "bloque": "14:00–14:30",
            "duracion": 30
        },
        {
            "agente": "Agente21",
            "dia": "Sábado",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente71",
            "dia": "Martes",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente48",
            "dia": "Viernes",
            "bloque": "16:30–17:00",
            "duracion": 30
        },
        {
            "agente": "Agente38",
            "dia": "Sábado",
            "bloque": "16:00–16:30",
            "duracion": 30
        },
        {
            "agente": "Agente11",
            "dia": "Sábado",
            "bloque": "10:00–10:30",
            "duracion": 30
        },
        {
            "agente": "Agente60",
            "dia": "Lunes",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente23",
            "dia": "Domingo",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente15",
            "dia": "Viernes",
            "bloque": "10:30–11:00",
            "duracion": 30
        },
        {
            "agente": "Agente61",
            "dia": "Sábado",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente45",
            "dia": "Viernes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente60",
            "dia": "Viernes",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente65",
            "dia": "Lunes",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente18",
            "dia": "Domingo",
            "bloque": "11:30–12:00",
            "duracion": 30
        },
        {
            "agente": "Agente70",
            "dia": "Domingo",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente22",
            "dia": "Viernes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente26",
            "dia": "Martes",
            "bloque": "12:30–13:00",
            "duracion": 30
        },
        {
            "agente": "Agente43",
            "dia": "Lunes",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente13",
            "dia": "Sábado",
            "bloque": "12:00–12:30",
            "duracion": 30
        },
        {
            "agente": "Agente17",
            "dia": "Sábado",
            "bloque": "13:00–13:30",
            "duracion": 30
        },
        {
            "agente": "Agente32",
            "dia": "Sábado",
            "bloque": "14:00–14:30",
            "duracion": 30
        },
        {
            "agente": "Agente52",
            "dia": "Sábado",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente66",
            "dia": "Domingo",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente47",
            "dia": "Lunes",
            "bloque": "17:30–18:00",
            "duracion": 30
        },
        {
            "agente": "Agente65",
            "dia": "Jueves",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente53",
            "dia": "Lunes",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente70",
            "dia": "Sábado",
            "bloque": "20:30–21:00",
            "duracion": 30
        },
        {
            "agente": "Agente40",
            "dia": "Viernes",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente44",
            "dia": "Lunes",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente41",
            "dia": "Lunes",
            "bloque": "16:30–17:00",
            "duracion": 30
        },
        {
            "agente": "Agente41",
            "dia": "Sábado",
            "bloque": "15:30–16:00",
            "duracion": 30
        },
        {
            "agente": "Agente51",
            "dia": "Miércoles",
            "bloque": "17:00–17:30",
            "duracion": 30
        },
        {
            "agente": "Agente68",
            "dia": "Viernes",
            "bloque": "20:00–20:30",
            "duracion": 30
        },
        {
            "agente": "Agente44",
            "dia": "Sábado",
            "bloque": "16:30–17:00",
            "duracion": 30
        },
        {
            "agente": "Agente54",
            "dia": "Jueves",
            "bloque": "16:30–17:00",
            "duracion": 30
        },
        {
            "agente": "Agente67",
            "dia": "Martes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente68",
            "dia": "Miércoles",
            "bloque": "20:00–20:30",
            "duracion": 30
        },
        {
            "agente": "Agente64",
            "dia": "Miércoles",
            "bloque": "18:30–19:00",
            "duracion": 30
        },
        {
            "agente": "Agente67",
            "dia": "Domingo",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente68",
            "dia": "Martes",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente71",
            "dia": "Sábado",
            "bloque": "19:30–20:00",
            "duracion": 30
        },
        {
            "agente": "Agente68",
            "dia": "Sábado",
            "bloque": "19:00–19:30",
            "duracion": 30
        },
        {
            "agente": "Agente47",
            "dia": "Miércoles",
            "bloque": "18:00–18:30",
            "duracion": 30
        },
        {
            "agente": "Agente50",
            "dia": "Viernes",
            "bloque": "17:30–18:00",
            "duracion": 30
        }
    ],
    "descansosTransformados": [
        {
            "agente": "Agente01",
            "lunes_30": "10:00–10:30",
            "martes_30": "11:00–11:30",
            "miércoles_30": "11:00–11:30",
            "jueves_30": "10:00–10:30",
            "viernes_30": "11:00–11:30",
            "sábado_30": "11:00–11:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente02",
            "lunes_30": "10:00–10:30",
            "martes_30": "09:00–09:30",
            "miércoles_30": "09:00–09:30",
            "jueves_30": "10:00–10:30",
            "viernes_30": "10:00–10:30",
            "sábado_30": "09:00–09:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente03",
            "lunes_30": "10:30–11:00",
            "martes_30": "10:00–10:30",
            "miércoles_30": "10:00–10:30",
            "jueves_30": "09:00–09:30",
            "viernes_30": "09:00–09:30",
            "sábado_30": "—",
            "domingo_30": "10:30–11:00"
        },
        {
            "agente": "Agente04",
            "lunes_30": "11:00–11:30",
            "martes_30": "11:00–11:30",
            "miércoles_30": "11:00–11:30",
            "jueves_30": "10:00–10:30",
            "viernes_30": "—",
            "sábado_30": "10:30–11:00",
            "domingo_30": "09:00–09:30"
        },
        {
            "agente": "Agente05",
            "lunes_30": "11:00–11:30",
            "martes_30": "11:00–11:30",
            "miércoles_30": "10:00–10:30",
            "jueves_30": "11:00–11:30",
            "viernes_30": "11:00–11:30",
            "sábado_30": "10:00–10:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente06",
            "lunes_30": "09:00–09:30",
            "martes_30": "10:00–10:30",
            "miércoles_30": "09:00–09:30",
            "jueves_30": "10:00–10:30",
            "viernes_30": "11:00–11:30",
            "sábado_30": "—",
            "domingo_30": "10:00–10:30"
        },
        {
            "agente": "Agente07",
            "lunes_30": "09:00–09:30",
            "martes_30": "11:00–11:30",
            "miércoles_30": "11:00–11:30",
            "jueves_30": "10:30–11:00",
            "viernes_30": "—",
            "sábado_30": "11:00–11:30",
            "domingo_30": "11:00–11:30"
        },
        {
            "agente": "Agente08",
            "lunes_30": "10:00–10:30",
            "martes_30": "11:00–11:30",
            "miércoles_30": "11:00–11:30",
            "jueves_30": "—",
            "viernes_30": "10:00–10:30",
            "sábado_30": "11:00–11:30",
            "domingo_30": "10:00–10:30"
        },
        {
            "agente": "Agente09",
            "lunes_30": "10:00–10:30",
            "martes_30": "10:00–10:30",
            "miércoles_30": "—",
            "jueves_30": "11:00–11:30",
            "viernes_30": "10:00–10:30",
            "sábado_30": "10:00–10:30",
            "domingo_30": "09:00–09:30"
        },
        {
            "agente": "Agente10",
            "lunes_30": "10:30–11:00",
            "martes_30": "10:30–11:00",
            "miércoles_30": "12:00–12:30",
            "jueves_30": "11:00–11:30",
            "viernes_30": "11:30–12:00",
            "sábado_30": "12:00–12:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente11",
            "lunes_30": "11:30–12:00",
            "martes_30": "11:30–12:00",
            "miércoles_30": "11:00–11:30",
            "jueves_30": "11:00–11:30",
            "viernes_30": "10:30–11:00",
            "sábado_30": "10:00–10:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente12",
            "lunes_30": "09:30–10:00",
            "martes_30": "11:30–12:00",
            "miércoles_30": "11:30–12:00",
            "jueves_30": "12:00–12:30",
            "viernes_30": "12:00–12:30",
            "sábado_30": "—",
            "domingo_30": "12:00–12:30"
        },
        {
            "agente": "Agente13",
            "lunes_30": "12:00–12:30",
            "martes_30": "11:00–11:30",
            "miércoles_30": "10:00–10:30",
            "jueves_30": "—",
            "viernes_30": "11:00–11:30",
            "sábado_30": "12:00–12:30",
            "domingo_30": "10:00–10:30"
        },
        {
            "agente": "Agente14",
            "lunes_30": "11:00–11:30",
            "martes_30": "11:30–12:00",
            "miércoles_30": "—",
            "jueves_30": "11:30–12:00",
            "viernes_30": "12:00–12:30",
            "sábado_30": "12:00–12:30",
            "domingo_30": "11:00–11:30"
        },
        {
            "agente": "Agente15",
            "lunes_30": "10:00–10:30",
            "martes_30": "—",
            "miércoles_30": "11:30–12:00",
            "jueves_30": "12:00–12:30",
            "viernes_30": "10:30–11:00",
            "sábado_30": "11:30–12:00",
            "domingo_30": "09:30–10:00"
        },
        {
            "agente": "Agente16",
            "lunes_30": "11:30–12:00",
            "martes_30": "12:00–12:30",
            "miércoles_30": "11:30–12:00",
            "jueves_30": "11:30–12:00",
            "viernes_30": "11:30–12:00",
            "sábado_30": "12:30–13:00",
            "domingo_30": "—"
        },
        {
            "agente": "Agente17",
            "lunes_30": "12:30–13:00",
            "martes_30": "12:30–13:00",
            "miércoles_30": "13:00–13:30",
            "jueves_30": "10:30–11:00",
            "viernes_30": "11:30–12:00",
            "sábado_30": "13:00–13:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente18",
            "lunes_30": "12:00–12:30",
            "martes_30": "10:30–11:00",
            "miércoles_30": "12:30–13:00",
            "jueves_30": "11:30–12:00",
            "viernes_30": "12:00–12:30",
            "sábado_30": "—",
            "domingo_30": "11:30–12:00"
        },
        {
            "agente": "Agente19",
            "lunes_30": "10:30–11:00",
            "martes_30": "12:30–13:00",
            "miércoles_30": "12:00–12:30",
            "jueves_30": "12:30–13:00",
            "viernes_30": "12:00–12:30",
            "sábado_30": "—",
            "domingo_30": "11:00–11:30"
        },
        {
            "agente": "Agente20",
            "lunes_30": "10:30–11:00",
            "martes_30": "12:00–12:30",
            "miércoles_30": "11:30–12:00",
            "jueves_30": "11:00–11:30",
            "viernes_30": "—",
            "sábado_30": "11:30–12:00",
            "domingo_30": "12:30–13:00"
        },
        {
            "agente": "Agente21",
            "lunes_30": "11:00–11:30",
            "martes_30": "11:30–12:00",
            "miércoles_30": "12:00–12:30",
            "jueves_30": "12:00–12:30",
            "viernes_30": "—",
            "sábado_30": "12:00–12:30",
            "domingo_30": "12:00–12:30"
        },
        {
            "agente": "Agente22",
            "lunes_30": "11:00–11:30",
            "martes_30": "12:00–12:30",
            "miércoles_30": "10:30–11:00",
            "jueves_30": "12:00–12:30",
            "viernes_30": "12:30–13:00",
            "sábado_30": "11:00–11:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente23",
            "lunes_30": "11:00–11:30",
            "martes_30": "12:30–13:00",
            "miércoles_30": "11:00–11:30",
            "jueves_30": "11:00–11:30",
            "viernes_30": "11:00–11:30",
            "sábado_30": "—",
            "domingo_30": "12:30–13:00"
        },
        {
            "agente": "Agente24",
            "lunes_30": "12:00–12:30",
            "martes_30": "11:30–12:00",
            "miércoles_30": "12:30–13:00",
            "jueves_30": "12:00–12:30",
            "viernes_30": "—",
            "sábado_30": "12:30–13:00",
            "domingo_30": "11:30–12:00"
        },
        {
            "agente": "Agente25",
            "lunes_30": "14:00–14:30",
            "martes_30": "12:00–12:30",
            "miércoles_30": "12:00–12:30",
            "jueves_30": "11:30–12:00",
            "viernes_30": "11:30–12:00",
            "sábado_30": "12:00–12:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente26",
            "lunes_30": "12:00–12:30",
            "martes_30": "12:30–13:00",
            "miércoles_30": "12:00–12:30",
            "jueves_30": "11:30–12:00",
            "viernes_30": "12:00–12:30",
            "sábado_30": "14:00–14:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente27",
            "lunes_30": "12:00–12:30",
            "martes_30": "13:30–14:00",
            "miércoles_30": "12:00–12:30",
            "jueves_30": "11:30–12:00",
            "viernes_30": "11:30–12:00",
            "sábado_30": "11:30–12:00",
            "domingo_30": "—"
        },
        {
            "agente": "Agente28",
            "lunes_30": "11:30–12:00",
            "martes_30": "12:00–12:30",
            "miércoles_30": "12:30–13:00",
            "jueves_30": "12:00–12:30",
            "viernes_30": "12:30–13:00",
            "sábado_30": "—",
            "domingo_30": "14:00–14:30"
        },
        {
            "agente": "Agente29",
            "lunes_30": "12:30–13:00",
            "martes_30": "12:00–12:30",
            "miércoles_30": "12:30–13:00",
            "jueves_30": "12:00–12:30",
            "viernes_30": "—",
            "sábado_30": "12:00–12:30",
            "domingo_30": "12:00–12:30"
        },
        {
            "agente": "Agente30",
            "lunes_30": "11:30–12:00",
            "martes_30": "14:00–14:30",
            "miércoles_30": "—",
            "jueves_30": "12:30–13:00",
            "viernes_30": "12:00–12:30",
            "sábado_30": "12:30–13:00",
            "domingo_30": "11:30–12:00"
        },
        {
            "agente": "Agente31",
            "lunes_30": "12:30–13:00",
            "martes_30": "12:30–13:00",
            "miércoles_30": "14:00–14:30",
            "jueves_30": "12:30–13:00",
            "viernes_30": "12:30–13:00",
            "sábado_30": "15:00–15:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente32",
            "lunes_30": "12:30–13:00",
            "martes_30": "12:30–13:00",
            "miércoles_30": "12:30–13:00",
            "jueves_30": "12:30–13:00",
            "viernes_30": "12:30–13:00",
            "sábado_30": "14:00–14:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente33",
            "lunes_30": "—",
            "martes_30": "15:00–15:30",
            "miércoles_30": "12:30–13:00",
            "jueves_30": "12:30–13:00",
            "viernes_30": "12:30–13:00",
            "sábado_30": "12:30–13:00",
            "domingo_30": "12:30–13:00"
        },
        {
            "agente": "Agente34",
            "lunes_30": "—",
            "martes_30": "14:00–14:30",
            "miércoles_30": "12:30–13:00",
            "jueves_30": "12:30–13:00",
            "viernes_30": "12:30–13:00",
            "sábado_30": "12:30–13:00",
            "domingo_30": "12:30–13:00"
        },
        {
            "agente": "Agente35",
            "lunes_30": "12:30–13:00",
            "martes_30": "12:30–13:00",
            "miércoles_30": "14:30–15:00",
            "jueves_30": "13:00–13:30",
            "viernes_30": "15:00–15:30",
            "sábado_30": "—",
            "domingo_30": "13:30–14:00"
        },
        {
            "agente": "Agente36",
            "lunes_30": "16:00–16:30",
            "martes_30": "15:30–16:00",
            "miércoles_30": "15:00–15:30",
            "jueves_30": "13:30–14:00",
            "viernes_30": "15:00–15:30",
            "sábado_30": "14:00–14:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente37",
            "lunes_30": "15:00–15:30",
            "martes_30": "14:30–15:00",
            "miércoles_30": "14:30–15:00",
            "jueves_30": "—",
            "viernes_30": "16:00–16:30",
            "sábado_30": "14:30–15:00",
            "domingo_30": "14:30–15:00"
        },
        {
            "agente": "Agente38",
            "lunes_30": "17:00–17:30",
            "martes_30": "17:00–17:30",
            "miércoles_30": "15:00–15:30",
            "jueves_30": "14:30–15:00",
            "viernes_30": "—",
            "sábado_30": "16:00–16:30",
            "domingo_30": "17:00–17:30"
        },
        {
            "agente": "Agente39",
            "lunes_30": "17:00–17:30",
            "martes_30": "15:00–15:30",
            "miércoles_30": "15:30–16:00",
            "jueves_30": "16:00–16:30",
            "viernes_30": "—",
            "sábado_30": "14:30–15:00",
            "domingo_30": "16:00–16:30"
        },
        {
            "agente": "Agente40",
            "lunes_30": "17:00–17:30",
            "martes_30": "17:00–17:30",
            "miércoles_30": "17:00–17:30",
            "jueves_30": "—",
            "viernes_30": "15:30–16:00",
            "sábado_30": "17:00–17:30",
            "domingo_30": "15:30–16:00"
        },
        {
            "agente": "Agente41",
            "lunes_30": "16:30–17:00",
            "martes_30": "17:30–18:00",
            "miércoles_30": "17:00–17:30",
            "jueves_30": "17:00–17:30",
            "viernes_30": "16:00–16:30",
            "sábado_30": "15:30–16:00",
            "domingo_30": "—"
        },
        {
            "agente": "Agente42",
            "lunes_30": "18:00–18:30",
            "martes_30": "15:30–16:00",
            "miércoles_30": "18:00–18:30",
            "jueves_30": "17:00–17:30",
            "viernes_30": "18:00–18:30",
            "sábado_30": "16:00–16:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente43",
            "lunes_30": "15:30–16:00",
            "martes_30": "17:00–17:30",
            "miércoles_30": "16:00–16:30",
            "jueves_30": "18:00–18:30",
            "viernes_30": "17:00–17:30",
            "sábado_30": "17:00–17:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente44",
            "lunes_30": "17:00–17:30",
            "martes_30": "18:00–18:30",
            "miércoles_30": "15:30–16:00",
            "jueves_30": "—",
            "viernes_30": "16:30–17:00",
            "sábado_30": "16:30–17:00",
            "domingo_30": "18:00–18:30"
        },
        {
            "agente": "Agente45",
            "lunes_30": "17:00–17:30",
            "martes_30": "16:00–16:30",
            "miércoles_30": "16:30–17:00",
            "jueves_30": "—",
            "viernes_30": "17:00–17:30",
            "sábado_30": "17:00–17:30",
            "domingo_30": "18:00–18:30"
        },
        {
            "agente": "Agente46",
            "lunes_30": "17:30–18:00",
            "martes_30": "15:30–16:00",
            "miércoles_30": "—",
            "jueves_30": "18:00–18:30",
            "viernes_30": "15:30–16:00",
            "sábado_30": "15:30–16:00",
            "domingo_30": "17:30–18:00"
        },
        {
            "agente": "Agente47",
            "lunes_30": "17:30–18:00",
            "martes_30": "17:00–17:30",
            "miércoles_30": "18:00–18:30",
            "jueves_30": "18:00–18:30",
            "viernes_30": "18:30–19:00",
            "sábado_30": "—",
            "domingo_30": "17:30–18:00"
        },
        {
            "agente": "Agente48",
            "lunes_30": "17:30–18:00",
            "martes_30": "18:00–18:30",
            "miércoles_30": "17:00–17:30",
            "jueves_30": "16:30–17:00",
            "viernes_30": "16:30–17:00",
            "sábado_30": "—",
            "domingo_30": "17:00–17:30"
        },
        {
            "agente": "Agente49",
            "lunes_30": "18:30–19:00",
            "martes_30": "17:30–18:00",
            "miércoles_30": "17:00–17:30",
            "jueves_30": "17:30–18:00",
            "viernes_30": "17:30–18:00",
            "sábado_30": "—",
            "domingo_30": "17:30–18:00"
        },
        {
            "agente": "Agente50",
            "lunes_30": "17:30–18:00",
            "martes_30": "16:30–17:00",
            "miércoles_30": "18:30–19:00",
            "jueves_30": "17:00–17:30",
            "viernes_30": "17:30–18:00",
            "sábado_30": "17:30–18:00",
            "domingo_30": "—"
        },
        {
            "agente": "Agente51",
            "lunes_30": "17:00–17:30",
            "martes_30": "18:00–18:30",
            "miércoles_30": "17:00–17:30",
            "jueves_30": "17:30–18:00",
            "viernes_30": "18:00–18:30",
            "sábado_30": "17:00–17:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente52",
            "lunes_30": "17:00–17:30",
            "martes_30": "17:00–17:30",
            "miércoles_30": "17:30–18:00",
            "jueves_30": "17:00–17:30",
            "viernes_30": "—",
            "sábado_30": "17:00–17:30",
            "domingo_30": "17:30–18:00"
        },
        {
            "agente": "Agente53",
            "lunes_30": "18:30–19:00",
            "martes_30": "17:30–18:00",
            "miércoles_30": "18:00–18:30",
            "jueves_30": "18:30–19:00",
            "viernes_30": "—",
            "sábado_30": "18:30–19:00",
            "domingo_30": "18:30–19:00"
        },
        {
            "agente": "Agente54",
            "lunes_30": "17:30–18:00",
            "martes_30": "17:00–17:30",
            "miércoles_30": "17:30–18:00",
            "jueves_30": "16:30–17:00",
            "viernes_30": "17:00–17:30",
            "sábado_30": "—",
            "domingo_30": "17:00–17:30"
        },
        {
            "agente": "Agente55",
            "lunes_30": "18:30–19:00",
            "martes_30": "17:30–18:00",
            "miércoles_30": "17:00–17:30",
            "jueves_30": "17:30–18:00",
            "viernes_30": "17:00–17:30",
            "sábado_30": "16:30–17:00",
            "domingo_30": "—"
        },
        {
            "agente": "Agente56",
            "lunes_30": "17:30–18:00",
            "martes_30": "19:00–19:30",
            "miércoles_30": "17:30–18:00",
            "jueves_30": "20:00–20:30",
            "viernes_30": "17:30–18:00",
            "sábado_30": "18:00–18:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente57",
            "lunes_30": "18:30–19:00",
            "martes_30": "18:30–19:00",
            "miércoles_30": "17:30–18:00",
            "jueves_30": "19:30–20:00",
            "viernes_30": "19:00–19:30",
            "sábado_30": "17:30–18:00",
            "domingo_30": "—"
        },
        {
            "agente": "Agente58",
            "lunes_30": "18:00–18:30",
            "martes_30": "19:30–20:00",
            "miércoles_30": "18:30–19:00",
            "jueves_30": "18:30–19:00",
            "viernes_30": "17:30–18:00",
            "sábado_30": "18:30–19:00",
            "domingo_30": "—"
        },
        {
            "agente": "Agente59",
            "lunes_30": "17:30–18:00",
            "martes_30": "18:30–19:00",
            "miércoles_30": "17:30–18:00",
            "jueves_30": "19:00–19:30",
            "viernes_30": "—",
            "sábado_30": "17:30–18:00",
            "domingo_30": "19:30–20:00"
        },
        {
            "agente": "Agente60",
            "lunes_30": "18:00–18:30",
            "martes_30": "17:30–18:00",
            "miércoles_30": "—",
            "jueves_30": "19:30–20:00",
            "viernes_30": "19:00–19:30",
            "sábado_30": "17:30–18:00",
            "domingo_30": "18:30–19:00"
        },
        {
            "agente": "Agente61",
            "lunes_30": "18:30–19:00",
            "martes_30": "—",
            "miércoles_30": "18:00–18:30",
            "jueves_30": "17:30–18:00",
            "viernes_30": "17:30–18:00",
            "sábado_30": "18:00–18:30",
            "domingo_30": "18:30–19:00"
        },
        {
            "agente": "Agente62",
            "lunes_30": "19:30–20:00",
            "martes_30": "20:30–21:00",
            "miércoles_30": "19:30–20:00",
            "jueves_30": "18:30–19:00",
            "viernes_30": "19:30–20:00",
            "sábado_30": "19:30–20:00",
            "domingo_30": "—"
        },
        {
            "agente": "Agente63",
            "lunes_30": "20:00–20:30",
            "martes_30": "18:30–19:00",
            "miércoles_30": "20:30–21:00",
            "jueves_30": "20:30–21:00",
            "viernes_30": "20:30–21:00",
            "sábado_30": "19:30–20:00",
            "domingo_30": "—"
        },
        {
            "agente": "Agente64",
            "lunes_30": "19:30–20:00",
            "martes_30": "19:30–20:00",
            "miércoles_30": "18:30–19:00",
            "jueves_30": "20:30–21:00",
            "viernes_30": "20:30–21:00",
            "sábado_30": "—",
            "domingo_30": "20:30–21:00"
        },
        {
            "agente": "Agente65",
            "lunes_30": "19:00–19:30",
            "martes_30": "19:00–19:30",
            "miércoles_30": "19:30–20:00",
            "jueves_30": "19:00–19:30",
            "viernes_30": "19:30–20:00",
            "sábado_30": "—",
            "domingo_30": "20:30–21:00"
        },
        {
            "agente": "Agente66",
            "lunes_30": "20:30–21:00",
            "martes_30": "18:30–19:00",
            "miércoles_30": "19:30–20:00",
            "jueves_30": "20:30–21:00",
            "viernes_30": "—",
            "sábado_30": "20:30–21:00",
            "domingo_30": "18:30–19:00"
        },
        {
            "agente": "Agente67",
            "lunes_30": "19:00–19:30",
            "martes_30": "19:30–20:00",
            "miércoles_30": "18:30–19:00",
            "jueves_30": "—",
            "viernes_30": "18:30–19:00",
            "sábado_30": "18:30–19:00",
            "domingo_30": "19:00–19:30"
        },
        {
            "agente": "Agente68",
            "lunes_30": "19:30–20:00",
            "martes_30": "19:30–20:00",
            "miércoles_30": "20:00–20:30",
            "jueves_30": "19:30–20:00",
            "viernes_30": "20:00–20:30",
            "sábado_30": "19:00–19:30",
            "domingo_30": "—"
        },
        {
            "agente": "Agente69",
            "lunes_30": "20:30–21:00",
            "martes_30": "20:30–21:00",
            "miércoles_30": "20:30–21:00",
            "jueves_30": "20:30–21:00",
            "viernes_30": "20:30–21:00",
            "sábado_30": "—",
            "domingo_30": "20:30–21:00"
        },
        {
            "agente": "Agente70",
            "lunes_30": "19:30–20:00",
            "martes_30": "19:30–20:00",
            "miércoles_30": "20:30–21:00",
            "jueves_30": "20:30–21:00",
            "viernes_30": "—",
            "sábado_30": "20:30–21:00",
            "domingo_30": "19:30–20:00"
        },
        {
            "agente": "Agente71",
            "lunes_30": "20:30–21:00",
            "martes_30": "20:30–21:00",
            "miércoles_30": "19:00–19:30",
            "jueves_30": "—",
            "viernes_30": "19:30–20:00",
            "sábado_30": "19:30–20:00",
            "domingo_30": "19:30–20:00"
        }
    ],
    "programacionSemanalFinal": {
        "Agente01": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "DS"
        },
        "Agente02": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "DS"
        },
        "Agente03": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "DS",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente04": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "DS",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente05": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "DS"
        },
        "Agente06": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "DS",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente07": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "DS",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente08": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "07:00:00-13:00:00",
            "Jueves": "DS",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente09": {
            "Lunes": "07:00:00-13:00:00",
            "Martes": "07:00:00-13:00:00",
            "Miércoles": "DS",
            "Jueves": "07:00:00-13:00:00",
            "Viernes": "07:00:00-13:00:00",
            "Sábado": "07:00:00-13:00:00",
            "Domingo": "07:00:00-13:00:00"
        },
        "Agente10": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "DS"
        },
        "Agente11": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "DS"
        },
        "Agente12": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "DS",
            "Domingo": "08:00:00-14:00:00"
        },
        "Agente13": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "DS",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "08:00:00-14:00:00"
        },
        "Agente14": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "08:00:00-14:00:00",
            "Miércoles": "DS",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "08:00:00-14:00:00"
        },
        "Agente15": {
            "Lunes": "08:00:00-14:00:00",
            "Martes": "DS",
            "Miércoles": "08:00:00-14:00:00",
            "Jueves": "08:00:00-14:00:00",
            "Viernes": "08:00:00-14:00:00",
            "Sábado": "08:00:00-14:00:00",
            "Domingo": "08:00:00-14:00:00"
        },
        "Agente16": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "DS"
        },
        "Agente17": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "DS"
        },
        "Agente18": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "DS",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente19": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "DS",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente20": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "DS",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente21": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "DS",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente22": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "DS"
        },
        "Agente23": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "09:00:00-15:00:00",
            "Sábado": "DS",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente24": {
            "Lunes": "09:00:00-15:00:00",
            "Martes": "09:00:00-15:00:00",
            "Miércoles": "09:00:00-15:00:00",
            "Jueves": "09:00:00-15:00:00",
            "Viernes": "DS",
            "Sábado": "09:00:00-15:00:00",
            "Domingo": "09:00:00-15:00:00"
        },
        "Agente25": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "DS"
        },
        "Agente26": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "DS"
        },
        "Agente27": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "DS"
        },
        "Agente28": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "DS",
            "Domingo": "10:00:00-16:00:00"
        },
        "Agente29": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "10:00:00-16:00:00",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "DS",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "10:00:00-16:00:00"
        },
        "Agente30": {
            "Lunes": "10:00:00-16:00:00",
            "Martes": "10:00:00-16:00:00",
            "Miércoles": "DS",
            "Jueves": "10:00:00-16:00:00",
            "Viernes": "10:00:00-16:00:00",
            "Sábado": "10:00:00-16:00:00",
            "Domingo": "10:00:00-16:00:00"
        },
        "Agente31": {
            "Lunes": "11:00:00-17:00:00",
            "Martes": "11:00:00-17:00:00",
            "Miércoles": "11:00:00-17:00:00",
            "Jueves": "11:00:00-17:00:00",
            "Viernes": "11:00:00-17:00:00",
            "Sábado": "11:00:00-17:00:00",
            "Domingo": "DS"
        },
        "Agente32": {
            "Lunes": "11:00:00-17:00:00",
            "Martes": "11:00:00-17:00:00",
            "Miércoles": "11:00:00-17:00:00",
            "Jueves": "11:00:00-17:00:00",
            "Viernes": "11:00:00-17:00:00",
            "Sábado": "11:00:00-17:00:00",
            "Domingo": "DS"
        },
        "Agente33": {
            "Lunes": "DS",
            "Martes": "11:00:00-17:00:00",
            "Miércoles": "11:00:00-17:00:00",
            "Jueves": "11:00:00-17:00:00",
            "Viernes": "11:00:00-17:00:00",
            "Sábado": "11:00:00-17:00:00",
            "Domingo": "11:00:00-17:00:00"
        },
        "Agente34": {
            "Lunes": "DS",
            "Martes": "11:00:00-17:00:00",
            "Miércoles": "11:00:00-17:00:00",
            "Jueves": "11:00:00-17:00:00",
            "Viernes": "11:00:00-17:00:00",
            "Sábado": "11:00:00-17:00:00",
            "Domingo": "11:00:00-17:00:00"
        },
        "Agente35": {
            "Lunes": "11:00:00-17:00:00",
            "Martes": "11:00:00-17:00:00",
            "Miércoles": "11:00:00-17:00:00",
            "Jueves": "11:00:00-17:00:00",
            "Viernes": "11:00:00-17:00:00",
            "Sábado": "DS",
            "Domingo": "11:00:00-17:00:00"
        },
        "Agente36": {
            "Lunes": "12:00:00-18:00:00",
            "Martes": "12:00:00-18:00:00",
            "Miércoles": "12:00:00-18:00:00",
            "Jueves": "12:00:00-18:00:00",
            "Viernes": "12:00:00-18:00:00",
            "Sábado": "12:00:00-18:00:00",
            "Domingo": "DS"
        },
        "Agente37": {
            "Lunes": "12:00:00-18:00:00",
            "Martes": "12:00:00-18:00:00",
            "Miércoles": "12:00:00-18:00:00",
            "Jueves": "DS",
            "Viernes": "12:00:00-18:00:00",
            "Sábado": "12:00:00-18:00:00",
            "Domingo": "12:00:00-18:00:00"
        },
        "Agente38": {
            "Lunes": "13:00:00-19:00:00",
            "Martes": "13:00:00-19:00:00",
            "Miércoles": "13:00:00-19:00:00",
            "Jueves": "13:00:00-19:00:00",
            "Viernes": "DS",
            "Sábado": "13:00:00-19:00:00",
            "Domingo": "13:00:00-19:00:00"
        },
        "Agente39": {
            "Lunes": "13:00:00-19:00:00",
            "Martes": "13:00:00-19:00:00",
            "Miércoles": "13:00:00-19:00:00",
            "Jueves": "13:00:00-19:00:00",
            "Viernes": "DS",
            "Sábado": "13:00:00-19:00:00",
            "Domingo": "13:00:00-19:00:00"
        },
        "Agente40": {
            "Lunes": "13:00:00-19:00:00",
            "Martes": "13:00:00-19:00:00",
            "Miércoles": "13:00:00-19:00:00",
            "Jueves": "DS",
            "Viernes": "13:00:00-19:00:00",
            "Sábado": "13:00:00-19:00:00",
            "Domingo": "13:00:00-19:00:00"
        },
        "Agente41": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "14:00:00-20:00:00",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "DS"
        },
        "Agente42": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "14:00:00-20:00:00",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "DS"
        },
        "Agente43": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "14:00:00-20:00:00",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "DS"
        },
        "Agente44": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "DS",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "14:00:00-20:00:00"
        },
        "Agente45": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "14:00:00-20:00:00",
            "Jueves": "DS",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "14:00:00-20:00:00"
        },
        "Agente46": {
            "Lunes": "14:00:00-20:00:00",
            "Martes": "14:00:00-20:00:00",
            "Miércoles": "DS",
            "Jueves": "14:00:00-20:00:00",
            "Viernes": "14:00:00-20:00:00",
            "Sábado": "14:00:00-20:00:00",
            "Domingo": "14:00:00-20:00:00"
        },
        "Agente47": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "DS",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente48": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "DS",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente49": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "DS",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente50": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "DS"
        },
        "Agente51": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "DS"
        },
        "Agente52": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "DS",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente53": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "DS",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente54": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "DS",
            "Domingo": "15:00:00-21:00:00"
        },
        "Agente55": {
            "Lunes": "15:00:00-21:00:00",
            "Martes": "15:00:00-21:00:00",
            "Miércoles": "15:00:00-21:00:00",
            "Jueves": "15:00:00-21:00:00",
            "Viernes": "15:00:00-21:00:00",
            "Sábado": "15:00:00-21:00:00",
            "Domingo": "DS"
        },
        "Agente56": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "DS"
        },
        "Agente57": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "DS"
        },
        "Agente58": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "DS"
        },
        "Agente59": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "DS",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "16:00:00-22:00:00"
        },
        "Agente60": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "16:00:00-22:00:00",
            "Miércoles": "DS",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "16:00:00-22:00:00"
        },
        "Agente61": {
            "Lunes": "16:00:00-22:00:00",
            "Martes": "DS",
            "Miércoles": "16:00:00-22:00:00",
            "Jueves": "16:00:00-22:00:00",
            "Viernes": "16:00:00-22:00:00",
            "Sábado": "16:00:00-22:00:00",
            "Domingo": "16:00:00-22:00:00"
        },
        "Agente62": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "DS"
        },
        "Agente63": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "DS"
        },
        "Agente64": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "DS",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente65": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "DS",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente66": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "DS",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente67": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "DS",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente68": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "DS"
        },
        "Agente69": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "DS",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente70": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "17:00:00-23:00:00",
            "Viernes": "DS",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        },
        "Agente71": {
            "Lunes": "17:00:00-23:00:00",
            "Martes": "17:00:00-23:00:00",
            "Miércoles": "17:00:00-23:00:00",
            "Jueves": "DS",
            "Viernes": "17:00:00-23:00:00",
            "Sábado": "17:00:00-23:00:00",
            "Domingo": "17:00:00-23:00:00"
        }
    },
    "columnasReceso": [
        {
            "text": "Agente",
            "value": "agente",
            "fixed": true
        },
        {
            "text": "Lunes (30)",
            "value": "lunes_30"
        },
        {
            "text": "Martes (30)",
            "value": "martes_30"
        },
        {
            "text": "Miércoles (30)",
            "value": "miércoles_30"
        },
        {
            "text": "Jueves (30)",
            "value": "jueves_30"
        },
        {
            "text": "Viernes (30)",
            "value": "viernes_30"
        },
        {
            "text": "Sábado (30)",
            "value": "sábado_30"
        },
        {
            "text": "Domingo (30)",
            "value": "domingo_30"
        }
    ],
    "itemsTablaResumen": [
        {
            "agente": "Agente01",
            "selected": false,
            "lunes_horario": "07:00–13:00",
            "lunes_receso60": "—",
            "lunes_receso30": "10:00–10:30",
            "lunes_receso15": "—",
            "martes_horario": "07:00–13:00",
            "martes_receso60": "—",
            "martes_receso30": "11:00–11:30",
            "martes_receso15": "—",
            "miércoles_horario": "07:00–13:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "11:00–11:30",
            "miércoles_receso15": "—",
            "jueves_horario": "07:00–13:00",
            "jueves_receso60": "—",
            "jueves_receso30": "10:00–10:30",
            "jueves_receso15": "—",
            "viernes_horario": "07:00–13:00",
            "viernes_receso60": "—",
            "viernes_receso30": "11:00–11:30",
            "viernes_receso15": "—",
            "sábado_horario": "07:00–13:00",
            "sábado_receso60": "—",
            "sábado_receso30": "11:00–11:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente02",
            "selected": false,
            "lunes_horario": "07:00–13:00",
            "lunes_receso60": "—",
            "lunes_receso30": "10:00–10:30",
            "lunes_receso15": "—",
            "martes_horario": "07:00–13:00",
            "martes_receso60": "—",
            "martes_receso30": "09:00–09:30",
            "martes_receso15": "—",
            "miércoles_horario": "07:00–13:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "09:00–09:30",
            "miércoles_receso15": "—",
            "jueves_horario": "07:00–13:00",
            "jueves_receso60": "—",
            "jueves_receso30": "10:00–10:30",
            "jueves_receso15": "—",
            "viernes_horario": "07:00–13:00",
            "viernes_receso60": "—",
            "viernes_receso30": "10:00–10:30",
            "viernes_receso15": "—",
            "sábado_horario": "07:00–13:00",
            "sábado_receso60": "—",
            "sábado_receso30": "09:00–09:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente03",
            "selected": false,
            "lunes_horario": "07:00–13:00",
            "lunes_receso60": "—",
            "lunes_receso30": "10:30–11:00",
            "lunes_receso15": "—",
            "martes_horario": "07:00–13:00",
            "martes_receso60": "—",
            "martes_receso30": "10:00–10:30",
            "martes_receso15": "—",
            "miércoles_horario": "07:00–13:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "10:00–10:30",
            "miércoles_receso15": "—",
            "jueves_horario": "07:00–13:00",
            "jueves_receso60": "—",
            "jueves_receso30": "09:00–09:30",
            "jueves_receso15": "—",
            "viernes_horario": "07:00–13:00",
            "viernes_receso60": "—",
            "viernes_receso30": "09:00–09:30",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "07:00–13:00",
            "domingo_receso60": "—",
            "domingo_receso30": "10:30–11:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente04",
            "selected": false,
            "lunes_horario": "07:00–13:00",
            "lunes_receso60": "—",
            "lunes_receso30": "11:00–11:30",
            "lunes_receso15": "—",
            "martes_horario": "07:00–13:00",
            "martes_receso60": "—",
            "martes_receso30": "11:00–11:30",
            "martes_receso15": "—",
            "miércoles_horario": "07:00–13:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "11:00–11:30",
            "miércoles_receso15": "—",
            "jueves_horario": "07:00–13:00",
            "jueves_receso60": "—",
            "jueves_receso30": "10:00–10:30",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "07:00–13:00",
            "sábado_receso60": "—",
            "sábado_receso30": "10:30–11:00",
            "sábado_receso15": "—",
            "domingo_horario": "07:00–13:00",
            "domingo_receso60": "—",
            "domingo_receso30": "09:00–09:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente05",
            "selected": false,
            "lunes_horario": "07:00–13:00",
            "lunes_receso60": "—",
            "lunes_receso30": "11:00–11:30",
            "lunes_receso15": "—",
            "martes_horario": "07:00–13:00",
            "martes_receso60": "—",
            "martes_receso30": "11:00–11:30",
            "martes_receso15": "—",
            "miércoles_horario": "07:00–13:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "10:00–10:30",
            "miércoles_receso15": "—",
            "jueves_horario": "07:00–13:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:00–11:30",
            "jueves_receso15": "—",
            "viernes_horario": "07:00–13:00",
            "viernes_receso60": "—",
            "viernes_receso30": "11:00–11:30",
            "viernes_receso15": "—",
            "sábado_horario": "07:00–13:00",
            "sábado_receso60": "—",
            "sábado_receso30": "10:00–10:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente06",
            "selected": false,
            "lunes_horario": "07:00–13:00",
            "lunes_receso60": "—",
            "lunes_receso30": "09:00–09:30",
            "lunes_receso15": "—",
            "martes_horario": "07:00–13:00",
            "martes_receso60": "—",
            "martes_receso30": "10:00–10:30",
            "martes_receso15": "—",
            "miércoles_horario": "07:00–13:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "09:00–09:30",
            "miércoles_receso15": "—",
            "jueves_horario": "07:00–13:00",
            "jueves_receso60": "—",
            "jueves_receso30": "10:00–10:30",
            "jueves_receso15": "—",
            "viernes_horario": "07:00–13:00",
            "viernes_receso60": "—",
            "viernes_receso30": "11:00–11:30",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "07:00–13:00",
            "domingo_receso60": "—",
            "domingo_receso30": "10:00–10:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente07",
            "selected": false,
            "lunes_horario": "07:00–13:00",
            "lunes_receso60": "—",
            "lunes_receso30": "09:00–09:30",
            "lunes_receso15": "—",
            "martes_horario": "07:00–13:00",
            "martes_receso60": "—",
            "martes_receso30": "11:00–11:30",
            "martes_receso15": "—",
            "miércoles_horario": "07:00–13:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "11:00–11:30",
            "miércoles_receso15": "—",
            "jueves_horario": "07:00–13:00",
            "jueves_receso60": "—",
            "jueves_receso30": "10:30–11:00",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "07:00–13:00",
            "sábado_receso60": "—",
            "sábado_receso30": "11:00–11:30",
            "sábado_receso15": "—",
            "domingo_horario": "07:00–13:00",
            "domingo_receso60": "—",
            "domingo_receso30": "11:00–11:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente08",
            "selected": false,
            "lunes_horario": "07:00–13:00",
            "lunes_receso60": "—",
            "lunes_receso30": "10:00–10:30",
            "lunes_receso15": "—",
            "martes_horario": "07:00–13:00",
            "martes_receso60": "—",
            "martes_receso30": "11:00–11:30",
            "martes_receso15": "—",
            "miércoles_horario": "07:00–13:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "11:00–11:30",
            "miércoles_receso15": "—",
            "jueves_horario": "DS",
            "jueves_receso60": "DS",
            "jueves_receso30": "DS",
            "jueves_receso15": "DS",
            "viernes_horario": "07:00–13:00",
            "viernes_receso60": "—",
            "viernes_receso30": "10:00–10:30",
            "viernes_receso15": "—",
            "sábado_horario": "07:00–13:00",
            "sábado_receso60": "—",
            "sábado_receso30": "11:00–11:30",
            "sábado_receso15": "—",
            "domingo_horario": "07:00–13:00",
            "domingo_receso60": "—",
            "domingo_receso30": "10:00–10:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente09",
            "selected": false,
            "lunes_horario": "07:00–13:00",
            "lunes_receso60": "—",
            "lunes_receso30": "10:00–10:30",
            "lunes_receso15": "—",
            "martes_horario": "07:00–13:00",
            "martes_receso60": "—",
            "martes_receso30": "10:00–10:30",
            "martes_receso15": "—",
            "miércoles_horario": "DS",
            "miércoles_receso60": "DS",
            "miércoles_receso30": "DS",
            "miércoles_receso15": "DS",
            "jueves_horario": "07:00–13:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:00–11:30",
            "jueves_receso15": "—",
            "viernes_horario": "07:00–13:00",
            "viernes_receso60": "—",
            "viernes_receso30": "10:00–10:30",
            "viernes_receso15": "—",
            "sábado_horario": "07:00–13:00",
            "sábado_receso60": "—",
            "sábado_receso30": "10:00–10:30",
            "sábado_receso15": "—",
            "domingo_horario": "07:00–13:00",
            "domingo_receso60": "—",
            "domingo_receso30": "09:00–09:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente10",
            "selected": false,
            "lunes_horario": "08:00–14:00",
            "lunes_receso60": "—",
            "lunes_receso30": "10:30–11:00",
            "lunes_receso15": "—",
            "martes_horario": "08:00–14:00",
            "martes_receso60": "—",
            "martes_receso30": "10:30–11:00",
            "martes_receso15": "—",
            "miércoles_horario": "08:00–14:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:00–12:30",
            "miércoles_receso15": "—",
            "jueves_horario": "08:00–14:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:00–11:30",
            "jueves_receso15": "—",
            "viernes_horario": "08:00–14:00",
            "viernes_receso60": "—",
            "viernes_receso30": "11:30–12:00",
            "viernes_receso15": "—",
            "sábado_horario": "08:00–14:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:00–12:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente11",
            "selected": false,
            "lunes_horario": "08:00–14:00",
            "lunes_receso60": "—",
            "lunes_receso30": "11:30–12:00",
            "lunes_receso15": "—",
            "martes_horario": "08:00–14:00",
            "martes_receso60": "—",
            "martes_receso30": "11:30–12:00",
            "martes_receso15": "—",
            "miércoles_horario": "08:00–14:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "11:00–11:30",
            "miércoles_receso15": "—",
            "jueves_horario": "08:00–14:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:00–11:30",
            "jueves_receso15": "—",
            "viernes_horario": "08:00–14:00",
            "viernes_receso60": "—",
            "viernes_receso30": "10:30–11:00",
            "viernes_receso15": "—",
            "sábado_horario": "08:00–14:00",
            "sábado_receso60": "—",
            "sábado_receso30": "10:00–10:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente12",
            "selected": false,
            "lunes_horario": "08:00–14:00",
            "lunes_receso60": "—",
            "lunes_receso30": "09:30–10:00",
            "lunes_receso15": "—",
            "martes_horario": "08:00–14:00",
            "martes_receso60": "—",
            "martes_receso30": "11:30–12:00",
            "martes_receso15": "—",
            "miércoles_horario": "08:00–14:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "11:30–12:00",
            "miércoles_receso15": "—",
            "jueves_horario": "08:00–14:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:00–12:30",
            "jueves_receso15": "—",
            "viernes_horario": "08:00–14:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:00–12:30",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "08:00–14:00",
            "domingo_receso60": "—",
            "domingo_receso30": "12:00–12:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente13",
            "selected": false,
            "lunes_horario": "08:00–14:00",
            "lunes_receso60": "—",
            "lunes_receso30": "12:00–12:30",
            "lunes_receso15": "—",
            "martes_horario": "08:00–14:00",
            "martes_receso60": "—",
            "martes_receso30": "11:00–11:30",
            "martes_receso15": "—",
            "miércoles_horario": "08:00–14:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "10:00–10:30",
            "miércoles_receso15": "—",
            "jueves_horario": "DS",
            "jueves_receso60": "DS",
            "jueves_receso30": "DS",
            "jueves_receso15": "DS",
            "viernes_horario": "08:00–14:00",
            "viernes_receso60": "—",
            "viernes_receso30": "11:00–11:30",
            "viernes_receso15": "—",
            "sábado_horario": "08:00–14:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:00–12:30",
            "sábado_receso15": "—",
            "domingo_horario": "08:00–14:00",
            "domingo_receso60": "—",
            "domingo_receso30": "10:00–10:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente14",
            "selected": false,
            "lunes_horario": "08:00–14:00",
            "lunes_receso60": "—",
            "lunes_receso30": "11:00–11:30",
            "lunes_receso15": "—",
            "martes_horario": "08:00–14:00",
            "martes_receso60": "—",
            "martes_receso30": "11:30–12:00",
            "martes_receso15": "—",
            "miércoles_horario": "DS",
            "miércoles_receso60": "DS",
            "miércoles_receso30": "DS",
            "miércoles_receso15": "DS",
            "jueves_horario": "08:00–14:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:30–12:00",
            "jueves_receso15": "—",
            "viernes_horario": "08:00–14:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:00–12:30",
            "viernes_receso15": "—",
            "sábado_horario": "08:00–14:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:00–12:30",
            "sábado_receso15": "—",
            "domingo_horario": "08:00–14:00",
            "domingo_receso60": "—",
            "domingo_receso30": "11:00–11:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente15",
            "selected": false,
            "lunes_horario": "08:00–14:00",
            "lunes_receso60": "—",
            "lunes_receso30": "10:00–10:30",
            "lunes_receso15": "—",
            "martes_horario": "DS",
            "martes_receso60": "DS",
            "martes_receso30": "DS",
            "martes_receso15": "DS",
            "miércoles_horario": "08:00–14:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "11:30–12:00",
            "miércoles_receso15": "—",
            "jueves_horario": "08:00–14:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:00–12:30",
            "jueves_receso15": "—",
            "viernes_horario": "08:00–14:00",
            "viernes_receso60": "—",
            "viernes_receso30": "10:30–11:00",
            "viernes_receso15": "—",
            "sábado_horario": "08:00–14:00",
            "sábado_receso60": "—",
            "sábado_receso30": "11:30–12:00",
            "sábado_receso15": "—",
            "domingo_horario": "08:00–14:00",
            "domingo_receso60": "—",
            "domingo_receso30": "09:30–10:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente16",
            "selected": false,
            "lunes_horario": "09:00–15:00",
            "lunes_receso60": "—",
            "lunes_receso30": "11:30–12:00",
            "lunes_receso15": "—",
            "martes_horario": "09:00–15:00",
            "martes_receso60": "—",
            "martes_receso30": "12:00–12:30",
            "martes_receso15": "—",
            "miércoles_horario": "09:00–15:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "11:30–12:00",
            "miércoles_receso15": "—",
            "jueves_horario": "09:00–15:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:30–12:00",
            "jueves_receso15": "—",
            "viernes_horario": "09:00–15:00",
            "viernes_receso60": "—",
            "viernes_receso30": "11:30–12:00",
            "viernes_receso15": "—",
            "sábado_horario": "09:00–15:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:30–13:00",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente17",
            "selected": false,
            "lunes_horario": "09:00–15:00",
            "lunes_receso60": "—",
            "lunes_receso30": "12:30–13:00",
            "lunes_receso15": "—",
            "martes_horario": "09:00–15:00",
            "martes_receso60": "—",
            "martes_receso30": "12:30–13:00",
            "martes_receso15": "—",
            "miércoles_horario": "09:00–15:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "13:00–13:30",
            "miércoles_receso15": "—",
            "jueves_horario": "09:00–15:00",
            "jueves_receso60": "—",
            "jueves_receso30": "10:30–11:00",
            "jueves_receso15": "—",
            "viernes_horario": "09:00–15:00",
            "viernes_receso60": "—",
            "viernes_receso30": "11:30–12:00",
            "viernes_receso15": "—",
            "sábado_horario": "09:00–15:00",
            "sábado_receso60": "—",
            "sábado_receso30": "13:00–13:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente18",
            "selected": false,
            "lunes_horario": "09:00–15:00",
            "lunes_receso60": "—",
            "lunes_receso30": "12:00–12:30",
            "lunes_receso15": "—",
            "martes_horario": "09:00–15:00",
            "martes_receso60": "—",
            "martes_receso30": "10:30–11:00",
            "martes_receso15": "—",
            "miércoles_horario": "09:00–15:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:30–13:00",
            "miércoles_receso15": "—",
            "jueves_horario": "09:00–15:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:30–12:00",
            "jueves_receso15": "—",
            "viernes_horario": "09:00–15:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:00–12:30",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "09:00–15:00",
            "domingo_receso60": "—",
            "domingo_receso30": "11:30–12:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente19",
            "selected": false,
            "lunes_horario": "09:00–15:00",
            "lunes_receso60": "—",
            "lunes_receso30": "10:30–11:00",
            "lunes_receso15": "—",
            "martes_horario": "09:00–15:00",
            "martes_receso60": "—",
            "martes_receso30": "12:30–13:00",
            "martes_receso15": "—",
            "miércoles_horario": "09:00–15:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:00–12:30",
            "miércoles_receso15": "—",
            "jueves_horario": "09:00–15:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:30–13:00",
            "jueves_receso15": "—",
            "viernes_horario": "09:00–15:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:00–12:30",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "09:00–15:00",
            "domingo_receso60": "—",
            "domingo_receso30": "11:00–11:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente20",
            "selected": false,
            "lunes_horario": "09:00–15:00",
            "lunes_receso60": "—",
            "lunes_receso30": "10:30–11:00",
            "lunes_receso15": "—",
            "martes_horario": "09:00–15:00",
            "martes_receso60": "—",
            "martes_receso30": "12:00–12:30",
            "martes_receso15": "—",
            "miércoles_horario": "09:00–15:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "11:30–12:00",
            "miércoles_receso15": "—",
            "jueves_horario": "09:00–15:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:00–11:30",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "09:00–15:00",
            "sábado_receso60": "—",
            "sábado_receso30": "11:30–12:00",
            "sábado_receso15": "—",
            "domingo_horario": "09:00–15:00",
            "domingo_receso60": "—",
            "domingo_receso30": "12:30–13:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente21",
            "selected": false,
            "lunes_horario": "09:00–15:00",
            "lunes_receso60": "—",
            "lunes_receso30": "11:00–11:30",
            "lunes_receso15": "—",
            "martes_horario": "09:00–15:00",
            "martes_receso60": "—",
            "martes_receso30": "11:30–12:00",
            "martes_receso15": "—",
            "miércoles_horario": "09:00–15:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:00–12:30",
            "miércoles_receso15": "—",
            "jueves_horario": "09:00–15:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:00–12:30",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "09:00–15:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:00–12:30",
            "sábado_receso15": "—",
            "domingo_horario": "09:00–15:00",
            "domingo_receso60": "—",
            "domingo_receso30": "12:00–12:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente22",
            "selected": false,
            "lunes_horario": "09:00–15:00",
            "lunes_receso60": "—",
            "lunes_receso30": "11:00–11:30",
            "lunes_receso15": "—",
            "martes_horario": "09:00–15:00",
            "martes_receso60": "—",
            "martes_receso30": "12:00–12:30",
            "martes_receso15": "—",
            "miércoles_horario": "09:00–15:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "10:30–11:00",
            "miércoles_receso15": "—",
            "jueves_horario": "09:00–15:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:00–12:30",
            "jueves_receso15": "—",
            "viernes_horario": "09:00–15:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:30–13:00",
            "viernes_receso15": "—",
            "sábado_horario": "09:00–15:00",
            "sábado_receso60": "—",
            "sábado_receso30": "11:00–11:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente23",
            "selected": false,
            "lunes_horario": "09:00–15:00",
            "lunes_receso60": "—",
            "lunes_receso30": "11:00–11:30",
            "lunes_receso15": "—",
            "martes_horario": "09:00–15:00",
            "martes_receso60": "—",
            "martes_receso30": "12:30–13:00",
            "martes_receso15": "—",
            "miércoles_horario": "09:00–15:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "11:00–11:30",
            "miércoles_receso15": "—",
            "jueves_horario": "09:00–15:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:00–11:30",
            "jueves_receso15": "—",
            "viernes_horario": "09:00–15:00",
            "viernes_receso60": "—",
            "viernes_receso30": "11:00–11:30",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "09:00–15:00",
            "domingo_receso60": "—",
            "domingo_receso30": "12:30–13:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente24",
            "selected": false,
            "lunes_horario": "09:00–15:00",
            "lunes_receso60": "—",
            "lunes_receso30": "12:00–12:30",
            "lunes_receso15": "—",
            "martes_horario": "09:00–15:00",
            "martes_receso60": "—",
            "martes_receso30": "11:30–12:00",
            "martes_receso15": "—",
            "miércoles_horario": "09:00–15:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:30–13:00",
            "miércoles_receso15": "—",
            "jueves_horario": "09:00–15:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:00–12:30",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "09:00–15:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:30–13:00",
            "sábado_receso15": "—",
            "domingo_horario": "09:00–15:00",
            "domingo_receso60": "—",
            "domingo_receso30": "11:30–12:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente25",
            "selected": false,
            "lunes_horario": "10:00–16:00",
            "lunes_receso60": "—",
            "lunes_receso30": "14:00–14:30",
            "lunes_receso15": "—",
            "martes_horario": "10:00–16:00",
            "martes_receso60": "—",
            "martes_receso30": "12:00–12:30",
            "martes_receso15": "—",
            "miércoles_horario": "10:00–16:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:00–12:30",
            "miércoles_receso15": "—",
            "jueves_horario": "10:00–16:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:30–12:00",
            "jueves_receso15": "—",
            "viernes_horario": "10:00–16:00",
            "viernes_receso60": "—",
            "viernes_receso30": "11:30–12:00",
            "viernes_receso15": "—",
            "sábado_horario": "10:00–16:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:00–12:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente26",
            "selected": false,
            "lunes_horario": "10:00–16:00",
            "lunes_receso60": "—",
            "lunes_receso30": "12:00–12:30",
            "lunes_receso15": "—",
            "martes_horario": "10:00–16:00",
            "martes_receso60": "—",
            "martes_receso30": "12:30–13:00",
            "martes_receso15": "—",
            "miércoles_horario": "10:00–16:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:00–12:30",
            "miércoles_receso15": "—",
            "jueves_horario": "10:00–16:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:30–12:00",
            "jueves_receso15": "—",
            "viernes_horario": "10:00–16:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:00–12:30",
            "viernes_receso15": "—",
            "sábado_horario": "10:00–16:00",
            "sábado_receso60": "—",
            "sábado_receso30": "14:00–14:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente27",
            "selected": false,
            "lunes_horario": "10:00–16:00",
            "lunes_receso60": "—",
            "lunes_receso30": "12:00–12:30",
            "lunes_receso15": "—",
            "martes_horario": "10:00–16:00",
            "martes_receso60": "—",
            "martes_receso30": "13:30–14:00",
            "martes_receso15": "—",
            "miércoles_horario": "10:00–16:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:00–12:30",
            "miércoles_receso15": "—",
            "jueves_horario": "10:00–16:00",
            "jueves_receso60": "—",
            "jueves_receso30": "11:30–12:00",
            "jueves_receso15": "—",
            "viernes_horario": "10:00–16:00",
            "viernes_receso60": "—",
            "viernes_receso30": "11:30–12:00",
            "viernes_receso15": "—",
            "sábado_horario": "10:00–16:00",
            "sábado_receso60": "—",
            "sábado_receso30": "11:30–12:00",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente28",
            "selected": false,
            "lunes_horario": "10:00–16:00",
            "lunes_receso60": "—",
            "lunes_receso30": "11:30–12:00",
            "lunes_receso15": "—",
            "martes_horario": "10:00–16:00",
            "martes_receso60": "—",
            "martes_receso30": "12:00–12:30",
            "martes_receso15": "—",
            "miércoles_horario": "10:00–16:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:30–13:00",
            "miércoles_receso15": "—",
            "jueves_horario": "10:00–16:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:00–12:30",
            "jueves_receso15": "—",
            "viernes_horario": "10:00–16:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:30–13:00",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "10:00–16:00",
            "domingo_receso60": "—",
            "domingo_receso30": "14:00–14:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente29",
            "selected": false,
            "lunes_horario": "10:00–16:00",
            "lunes_receso60": "—",
            "lunes_receso30": "12:30–13:00",
            "lunes_receso15": "—",
            "martes_horario": "10:00–16:00",
            "martes_receso60": "—",
            "martes_receso30": "12:00–12:30",
            "martes_receso15": "—",
            "miércoles_horario": "10:00–16:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:30–13:00",
            "miércoles_receso15": "—",
            "jueves_horario": "10:00–16:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:00–12:30",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "10:00–16:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:00–12:30",
            "sábado_receso15": "—",
            "domingo_horario": "10:00–16:00",
            "domingo_receso60": "—",
            "domingo_receso30": "12:00–12:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente30",
            "selected": false,
            "lunes_horario": "10:00–16:00",
            "lunes_receso60": "—",
            "lunes_receso30": "11:30–12:00",
            "lunes_receso15": "—",
            "martes_horario": "10:00–16:00",
            "martes_receso60": "—",
            "martes_receso30": "14:00–14:30",
            "martes_receso15": "—",
            "miércoles_horario": "DS",
            "miércoles_receso60": "DS",
            "miércoles_receso30": "DS",
            "miércoles_receso15": "DS",
            "jueves_horario": "10:00–16:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:30–13:00",
            "jueves_receso15": "—",
            "viernes_horario": "10:00–16:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:00–12:30",
            "viernes_receso15": "—",
            "sábado_horario": "10:00–16:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:30–13:00",
            "sábado_receso15": "—",
            "domingo_horario": "10:00–16:00",
            "domingo_receso60": "—",
            "domingo_receso30": "11:30–12:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente31",
            "selected": false,
            "lunes_horario": "11:00–17:00",
            "lunes_receso60": "—",
            "lunes_receso30": "12:30–13:00",
            "lunes_receso15": "—",
            "martes_horario": "11:00–17:00",
            "martes_receso60": "—",
            "martes_receso30": "12:30–13:00",
            "martes_receso15": "—",
            "miércoles_horario": "11:00–17:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "14:00–14:30",
            "miércoles_receso15": "—",
            "jueves_horario": "11:00–17:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:30–13:00",
            "jueves_receso15": "—",
            "viernes_horario": "11:00–17:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:30–13:00",
            "viernes_receso15": "—",
            "sábado_horario": "11:00–17:00",
            "sábado_receso60": "—",
            "sábado_receso30": "15:00–15:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente32",
            "selected": false,
            "lunes_horario": "11:00–17:00",
            "lunes_receso60": "—",
            "lunes_receso30": "12:30–13:00",
            "lunes_receso15": "—",
            "martes_horario": "11:00–17:00",
            "martes_receso60": "—",
            "martes_receso30": "12:30–13:00",
            "martes_receso15": "—",
            "miércoles_horario": "11:00–17:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:30–13:00",
            "miércoles_receso15": "—",
            "jueves_horario": "11:00–17:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:30–13:00",
            "jueves_receso15": "—",
            "viernes_horario": "11:00–17:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:30–13:00",
            "viernes_receso15": "—",
            "sábado_horario": "11:00–17:00",
            "sábado_receso60": "—",
            "sábado_receso30": "14:00–14:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente33",
            "selected": false,
            "lunes_horario": "DS",
            "lunes_receso60": "DS",
            "lunes_receso30": "DS",
            "lunes_receso15": "DS",
            "martes_horario": "11:00–17:00",
            "martes_receso60": "—",
            "martes_receso30": "15:00–15:30",
            "martes_receso15": "—",
            "miércoles_horario": "11:00–17:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:30–13:00",
            "miércoles_receso15": "—",
            "jueves_horario": "11:00–17:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:30–13:00",
            "jueves_receso15": "—",
            "viernes_horario": "11:00–17:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:30–13:00",
            "viernes_receso15": "—",
            "sábado_horario": "11:00–17:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:30–13:00",
            "sábado_receso15": "—",
            "domingo_horario": "11:00–17:00",
            "domingo_receso60": "—",
            "domingo_receso30": "12:30–13:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente34",
            "selected": false,
            "lunes_horario": "DS",
            "lunes_receso60": "DS",
            "lunes_receso30": "DS",
            "lunes_receso15": "DS",
            "martes_horario": "11:00–17:00",
            "martes_receso60": "—",
            "martes_receso30": "14:00–14:30",
            "martes_receso15": "—",
            "miércoles_horario": "11:00–17:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "12:30–13:00",
            "miércoles_receso15": "—",
            "jueves_horario": "11:00–17:00",
            "jueves_receso60": "—",
            "jueves_receso30": "12:30–13:00",
            "jueves_receso15": "—",
            "viernes_horario": "11:00–17:00",
            "viernes_receso60": "—",
            "viernes_receso30": "12:30–13:00",
            "viernes_receso15": "—",
            "sábado_horario": "11:00–17:00",
            "sábado_receso60": "—",
            "sábado_receso30": "12:30–13:00",
            "sábado_receso15": "—",
            "domingo_horario": "11:00–17:00",
            "domingo_receso60": "—",
            "domingo_receso30": "12:30–13:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente35",
            "selected": false,
            "lunes_horario": "11:00–17:00",
            "lunes_receso60": "—",
            "lunes_receso30": "12:30–13:00",
            "lunes_receso15": "—",
            "martes_horario": "11:00–17:00",
            "martes_receso60": "—",
            "martes_receso30": "12:30–13:00",
            "martes_receso15": "—",
            "miércoles_horario": "11:00–17:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "14:30–15:00",
            "miércoles_receso15": "—",
            "jueves_horario": "11:00–17:00",
            "jueves_receso60": "—",
            "jueves_receso30": "13:00–13:30",
            "jueves_receso15": "—",
            "viernes_horario": "11:00–17:00",
            "viernes_receso60": "—",
            "viernes_receso30": "15:00–15:30",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "11:00–17:00",
            "domingo_receso60": "—",
            "domingo_receso30": "13:30–14:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente36",
            "selected": false,
            "lunes_horario": "12:00–18:00",
            "lunes_receso60": "—",
            "lunes_receso30": "16:00–16:30",
            "lunes_receso15": "—",
            "martes_horario": "12:00–18:00",
            "martes_receso60": "—",
            "martes_receso30": "15:30–16:00",
            "martes_receso15": "—",
            "miércoles_horario": "12:00–18:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "15:00–15:30",
            "miércoles_receso15": "—",
            "jueves_horario": "12:00–18:00",
            "jueves_receso60": "—",
            "jueves_receso30": "13:30–14:00",
            "jueves_receso15": "—",
            "viernes_horario": "12:00–18:00",
            "viernes_receso60": "—",
            "viernes_receso30": "15:00–15:30",
            "viernes_receso15": "—",
            "sábado_horario": "12:00–18:00",
            "sábado_receso60": "—",
            "sábado_receso30": "14:00–14:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente37",
            "selected": false,
            "lunes_horario": "12:00–18:00",
            "lunes_receso60": "—",
            "lunes_receso30": "15:00–15:30",
            "lunes_receso15": "—",
            "martes_horario": "12:00–18:00",
            "martes_receso60": "—",
            "martes_receso30": "14:30–15:00",
            "martes_receso15": "—",
            "miércoles_horario": "12:00–18:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "14:30–15:00",
            "miércoles_receso15": "—",
            "jueves_horario": "DS",
            "jueves_receso60": "DS",
            "jueves_receso30": "DS",
            "jueves_receso15": "DS",
            "viernes_horario": "12:00–18:00",
            "viernes_receso60": "—",
            "viernes_receso30": "16:00–16:30",
            "viernes_receso15": "—",
            "sábado_horario": "12:00–18:00",
            "sábado_receso60": "—",
            "sábado_receso30": "14:30–15:00",
            "sábado_receso15": "—",
            "domingo_horario": "12:00–18:00",
            "domingo_receso60": "—",
            "domingo_receso30": "14:30–15:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente38",
            "selected": false,
            "lunes_horario": "13:00–19:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:00–17:30",
            "lunes_receso15": "—",
            "martes_horario": "13:00–19:00",
            "martes_receso60": "—",
            "martes_receso30": "17:00–17:30",
            "martes_receso15": "—",
            "miércoles_horario": "13:00–19:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "15:00–15:30",
            "miércoles_receso15": "—",
            "jueves_horario": "13:00–19:00",
            "jueves_receso60": "—",
            "jueves_receso30": "14:30–15:00",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "13:00–19:00",
            "sábado_receso60": "—",
            "sábado_receso30": "16:00–16:30",
            "sábado_receso15": "—",
            "domingo_horario": "13:00–19:00",
            "domingo_receso60": "—",
            "domingo_receso30": "17:00–17:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente39",
            "selected": false,
            "lunes_horario": "13:00–19:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:00–17:30",
            "lunes_receso15": "—",
            "martes_horario": "13:00–19:00",
            "martes_receso60": "—",
            "martes_receso30": "15:00–15:30",
            "martes_receso15": "—",
            "miércoles_horario": "13:00–19:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "15:30–16:00",
            "miércoles_receso15": "—",
            "jueves_horario": "13:00–19:00",
            "jueves_receso60": "—",
            "jueves_receso30": "16:00–16:30",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "13:00–19:00",
            "sábado_receso60": "—",
            "sábado_receso30": "14:30–15:00",
            "sábado_receso15": "—",
            "domingo_horario": "13:00–19:00",
            "domingo_receso60": "—",
            "domingo_receso30": "16:00–16:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente40",
            "selected": false,
            "lunes_horario": "13:00–19:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:00–17:30",
            "lunes_receso15": "—",
            "martes_horario": "13:00–19:00",
            "martes_receso60": "—",
            "martes_receso30": "17:00–17:30",
            "martes_receso15": "—",
            "miércoles_horario": "13:00–19:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:00–17:30",
            "miércoles_receso15": "—",
            "jueves_horario": "DS",
            "jueves_receso60": "DS",
            "jueves_receso30": "DS",
            "jueves_receso15": "DS",
            "viernes_horario": "13:00–19:00",
            "viernes_receso60": "—",
            "viernes_receso30": "15:30–16:00",
            "viernes_receso15": "—",
            "sábado_horario": "13:00–19:00",
            "sábado_receso60": "—",
            "sábado_receso30": "17:00–17:30",
            "sábado_receso15": "—",
            "domingo_horario": "13:00–19:00",
            "domingo_receso60": "—",
            "domingo_receso30": "15:30–16:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente41",
            "selected": false,
            "lunes_horario": "14:00–20:00",
            "lunes_receso60": "—",
            "lunes_receso30": "16:30–17:00",
            "lunes_receso15": "—",
            "martes_horario": "14:00–20:00",
            "martes_receso60": "—",
            "martes_receso30": "17:30–18:00",
            "martes_receso15": "—",
            "miércoles_horario": "14:00–20:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:00–17:30",
            "miércoles_receso15": "—",
            "jueves_horario": "14:00–20:00",
            "jueves_receso60": "—",
            "jueves_receso30": "17:00–17:30",
            "jueves_receso15": "—",
            "viernes_horario": "14:00–20:00",
            "viernes_receso60": "—",
            "viernes_receso30": "16:00–16:30",
            "viernes_receso15": "—",
            "sábado_horario": "14:00–20:00",
            "sábado_receso60": "—",
            "sábado_receso30": "15:30–16:00",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente42",
            "selected": false,
            "lunes_horario": "14:00–20:00",
            "lunes_receso60": "—",
            "lunes_receso30": "18:00–18:30",
            "lunes_receso15": "—",
            "martes_horario": "14:00–20:00",
            "martes_receso60": "—",
            "martes_receso30": "15:30–16:00",
            "martes_receso15": "—",
            "miércoles_horario": "14:00–20:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "18:00–18:30",
            "miércoles_receso15": "—",
            "jueves_horario": "14:00–20:00",
            "jueves_receso60": "—",
            "jueves_receso30": "17:00–17:30",
            "jueves_receso15": "—",
            "viernes_horario": "14:00–20:00",
            "viernes_receso60": "—",
            "viernes_receso30": "18:00–18:30",
            "viernes_receso15": "—",
            "sábado_horario": "14:00–20:00",
            "sábado_receso60": "—",
            "sábado_receso30": "16:00–16:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente43",
            "selected": false,
            "lunes_horario": "14:00–20:00",
            "lunes_receso60": "—",
            "lunes_receso30": "15:30–16:00",
            "lunes_receso15": "—",
            "martes_horario": "14:00–20:00",
            "martes_receso60": "—",
            "martes_receso30": "17:00–17:30",
            "martes_receso15": "—",
            "miércoles_horario": "14:00–20:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "16:00–16:30",
            "miércoles_receso15": "—",
            "jueves_horario": "14:00–20:00",
            "jueves_receso60": "—",
            "jueves_receso30": "18:00–18:30",
            "jueves_receso15": "—",
            "viernes_horario": "14:00–20:00",
            "viernes_receso60": "—",
            "viernes_receso30": "17:00–17:30",
            "viernes_receso15": "—",
            "sábado_horario": "14:00–20:00",
            "sábado_receso60": "—",
            "sábado_receso30": "17:00–17:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente44",
            "selected": false,
            "lunes_horario": "14:00–20:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:00–17:30",
            "lunes_receso15": "—",
            "martes_horario": "14:00–20:00",
            "martes_receso60": "—",
            "martes_receso30": "18:00–18:30",
            "martes_receso15": "—",
            "miércoles_horario": "14:00–20:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "15:30–16:00",
            "miércoles_receso15": "—",
            "jueves_horario": "DS",
            "jueves_receso60": "DS",
            "jueves_receso30": "DS",
            "jueves_receso15": "DS",
            "viernes_horario": "14:00–20:00",
            "viernes_receso60": "—",
            "viernes_receso30": "16:30–17:00",
            "viernes_receso15": "—",
            "sábado_horario": "14:00–20:00",
            "sábado_receso60": "—",
            "sábado_receso30": "16:30–17:00",
            "sábado_receso15": "—",
            "domingo_horario": "14:00–20:00",
            "domingo_receso60": "—",
            "domingo_receso30": "18:00–18:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente45",
            "selected": false,
            "lunes_horario": "14:00–20:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:00–17:30",
            "lunes_receso15": "—",
            "martes_horario": "14:00–20:00",
            "martes_receso60": "—",
            "martes_receso30": "16:00–16:30",
            "martes_receso15": "—",
            "miércoles_horario": "14:00–20:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "16:30–17:00",
            "miércoles_receso15": "—",
            "jueves_horario": "DS",
            "jueves_receso60": "DS",
            "jueves_receso30": "DS",
            "jueves_receso15": "DS",
            "viernes_horario": "14:00–20:00",
            "viernes_receso60": "—",
            "viernes_receso30": "17:00–17:30",
            "viernes_receso15": "—",
            "sábado_horario": "14:00–20:00",
            "sábado_receso60": "—",
            "sábado_receso30": "17:00–17:30",
            "sábado_receso15": "—",
            "domingo_horario": "14:00–20:00",
            "domingo_receso60": "—",
            "domingo_receso30": "18:00–18:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente46",
            "selected": false,
            "lunes_horario": "14:00–20:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:30–18:00",
            "lunes_receso15": "—",
            "martes_horario": "14:00–20:00",
            "martes_receso60": "—",
            "martes_receso30": "15:30–16:00",
            "martes_receso15": "—",
            "miércoles_horario": "DS",
            "miércoles_receso60": "DS",
            "miércoles_receso30": "DS",
            "miércoles_receso15": "DS",
            "jueves_horario": "14:00–20:00",
            "jueves_receso60": "—",
            "jueves_receso30": "18:00–18:30",
            "jueves_receso15": "—",
            "viernes_horario": "14:00–20:00",
            "viernes_receso60": "—",
            "viernes_receso30": "15:30–16:00",
            "viernes_receso15": "—",
            "sábado_horario": "14:00–20:00",
            "sábado_receso60": "—",
            "sábado_receso30": "15:30–16:00",
            "sábado_receso15": "—",
            "domingo_horario": "14:00–20:00",
            "domingo_receso60": "—",
            "domingo_receso30": "17:30–18:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente47",
            "selected": false,
            "lunes_horario": "15:00–21:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:30–18:00",
            "lunes_receso15": "—",
            "martes_horario": "15:00–21:00",
            "martes_receso60": "—",
            "martes_receso30": "17:00–17:30",
            "martes_receso15": "—",
            "miércoles_horario": "15:00–21:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "18:00–18:30",
            "miércoles_receso15": "—",
            "jueves_horario": "15:00–21:00",
            "jueves_receso60": "—",
            "jueves_receso30": "18:00–18:30",
            "jueves_receso15": "—",
            "viernes_horario": "15:00–21:00",
            "viernes_receso60": "—",
            "viernes_receso30": "18:30–19:00",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "15:00–21:00",
            "domingo_receso60": "—",
            "domingo_receso30": "17:30–18:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente48",
            "selected": false,
            "lunes_horario": "15:00–21:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:30–18:00",
            "lunes_receso15": "—",
            "martes_horario": "15:00–21:00",
            "martes_receso60": "—",
            "martes_receso30": "18:00–18:30",
            "martes_receso15": "—",
            "miércoles_horario": "15:00–21:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:00–17:30",
            "miércoles_receso15": "—",
            "jueves_horario": "15:00–21:00",
            "jueves_receso60": "—",
            "jueves_receso30": "16:30–17:00",
            "jueves_receso15": "—",
            "viernes_horario": "15:00–21:00",
            "viernes_receso60": "—",
            "viernes_receso30": "16:30–17:00",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "15:00–21:00",
            "domingo_receso60": "—",
            "domingo_receso30": "17:00–17:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente49",
            "selected": false,
            "lunes_horario": "15:00–21:00",
            "lunes_receso60": "—",
            "lunes_receso30": "18:30–19:00",
            "lunes_receso15": "—",
            "martes_horario": "15:00–21:00",
            "martes_receso60": "—",
            "martes_receso30": "17:30–18:00",
            "martes_receso15": "—",
            "miércoles_horario": "15:00–21:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:00–17:30",
            "miércoles_receso15": "—",
            "jueves_horario": "15:00–21:00",
            "jueves_receso60": "—",
            "jueves_receso30": "17:30–18:00",
            "jueves_receso15": "—",
            "viernes_horario": "15:00–21:00",
            "viernes_receso60": "—",
            "viernes_receso30": "17:30–18:00",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "15:00–21:00",
            "domingo_receso60": "—",
            "domingo_receso30": "17:30–18:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente50",
            "selected": false,
            "lunes_horario": "15:00–21:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:30–18:00",
            "lunes_receso15": "—",
            "martes_horario": "15:00–21:00",
            "martes_receso60": "—",
            "martes_receso30": "16:30–17:00",
            "martes_receso15": "—",
            "miércoles_horario": "15:00–21:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "18:30–19:00",
            "miércoles_receso15": "—",
            "jueves_horario": "15:00–21:00",
            "jueves_receso60": "—",
            "jueves_receso30": "17:00–17:30",
            "jueves_receso15": "—",
            "viernes_horario": "15:00–21:00",
            "viernes_receso60": "—",
            "viernes_receso30": "17:30–18:00",
            "viernes_receso15": "—",
            "sábado_horario": "15:00–21:00",
            "sábado_receso60": "—",
            "sábado_receso30": "17:30–18:00",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente51",
            "selected": false,
            "lunes_horario": "15:00–21:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:00–17:30",
            "lunes_receso15": "—",
            "martes_horario": "15:00–21:00",
            "martes_receso60": "—",
            "martes_receso30": "18:00–18:30",
            "martes_receso15": "—",
            "miércoles_horario": "15:00–21:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:00–17:30",
            "miércoles_receso15": "—",
            "jueves_horario": "15:00–21:00",
            "jueves_receso60": "—",
            "jueves_receso30": "17:30–18:00",
            "jueves_receso15": "—",
            "viernes_horario": "15:00–21:00",
            "viernes_receso60": "—",
            "viernes_receso30": "18:00–18:30",
            "viernes_receso15": "—",
            "sábado_horario": "15:00–21:00",
            "sábado_receso60": "—",
            "sábado_receso30": "17:00–17:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente52",
            "selected": false,
            "lunes_horario": "15:00–21:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:00–17:30",
            "lunes_receso15": "—",
            "martes_horario": "15:00–21:00",
            "martes_receso60": "—",
            "martes_receso30": "17:00–17:30",
            "martes_receso15": "—",
            "miércoles_horario": "15:00–21:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:30–18:00",
            "miércoles_receso15": "—",
            "jueves_horario": "15:00–21:00",
            "jueves_receso60": "—",
            "jueves_receso30": "17:00–17:30",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "15:00–21:00",
            "sábado_receso60": "—",
            "sábado_receso30": "17:00–17:30",
            "sábado_receso15": "—",
            "domingo_horario": "15:00–21:00",
            "domingo_receso60": "—",
            "domingo_receso30": "17:30–18:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente53",
            "selected": false,
            "lunes_horario": "15:00–21:00",
            "lunes_receso60": "—",
            "lunes_receso30": "18:30–19:00",
            "lunes_receso15": "—",
            "martes_horario": "15:00–21:00",
            "martes_receso60": "—",
            "martes_receso30": "17:30–18:00",
            "martes_receso15": "—",
            "miércoles_horario": "15:00–21:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "18:00–18:30",
            "miércoles_receso15": "—",
            "jueves_horario": "15:00–21:00",
            "jueves_receso60": "—",
            "jueves_receso30": "18:30–19:00",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "15:00–21:00",
            "sábado_receso60": "—",
            "sábado_receso30": "18:30–19:00",
            "sábado_receso15": "—",
            "domingo_horario": "15:00–21:00",
            "domingo_receso60": "—",
            "domingo_receso30": "18:30–19:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente54",
            "selected": false,
            "lunes_horario": "15:00–21:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:30–18:00",
            "lunes_receso15": "—",
            "martes_horario": "15:00–21:00",
            "martes_receso60": "—",
            "martes_receso30": "17:00–17:30",
            "martes_receso15": "—",
            "miércoles_horario": "15:00–21:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:30–18:00",
            "miércoles_receso15": "—",
            "jueves_horario": "15:00–21:00",
            "jueves_receso60": "—",
            "jueves_receso30": "16:30–17:00",
            "jueves_receso15": "—",
            "viernes_horario": "15:00–21:00",
            "viernes_receso60": "—",
            "viernes_receso30": "17:00–17:30",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "15:00–21:00",
            "domingo_receso60": "—",
            "domingo_receso30": "17:00–17:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente55",
            "selected": false,
            "lunes_horario": "15:00–21:00",
            "lunes_receso60": "—",
            "lunes_receso30": "18:30–19:00",
            "lunes_receso15": "—",
            "martes_horario": "15:00–21:00",
            "martes_receso60": "—",
            "martes_receso30": "17:30–18:00",
            "martes_receso15": "—",
            "miércoles_horario": "15:00–21:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:00–17:30",
            "miércoles_receso15": "—",
            "jueves_horario": "15:00–21:00",
            "jueves_receso60": "—",
            "jueves_receso30": "17:30–18:00",
            "jueves_receso15": "—",
            "viernes_horario": "15:00–21:00",
            "viernes_receso60": "—",
            "viernes_receso30": "17:00–17:30",
            "viernes_receso15": "—",
            "sábado_horario": "15:00–21:00",
            "sábado_receso60": "—",
            "sábado_receso30": "16:30–17:00",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente56",
            "selected": false,
            "lunes_horario": "16:00–22:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:30–18:00",
            "lunes_receso15": "—",
            "martes_horario": "16:00–22:00",
            "martes_receso60": "—",
            "martes_receso30": "19:00–19:30",
            "martes_receso15": "—",
            "miércoles_horario": "16:00–22:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:30–18:00",
            "miércoles_receso15": "—",
            "jueves_horario": "16:00–22:00",
            "jueves_receso60": "—",
            "jueves_receso30": "20:00–20:30",
            "jueves_receso15": "—",
            "viernes_horario": "16:00–22:00",
            "viernes_receso60": "—",
            "viernes_receso30": "17:30–18:00",
            "viernes_receso15": "—",
            "sábado_horario": "16:00–22:00",
            "sábado_receso60": "—",
            "sábado_receso30": "18:00–18:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente57",
            "selected": false,
            "lunes_horario": "16:00–22:00",
            "lunes_receso60": "—",
            "lunes_receso30": "18:30–19:00",
            "lunes_receso15": "—",
            "martes_horario": "16:00–22:00",
            "martes_receso60": "—",
            "martes_receso30": "18:30–19:00",
            "martes_receso15": "—",
            "miércoles_horario": "16:00–22:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:30–18:00",
            "miércoles_receso15": "—",
            "jueves_horario": "16:00–22:00",
            "jueves_receso60": "—",
            "jueves_receso30": "19:30–20:00",
            "jueves_receso15": "—",
            "viernes_horario": "16:00–22:00",
            "viernes_receso60": "—",
            "viernes_receso30": "19:00–19:30",
            "viernes_receso15": "—",
            "sábado_horario": "16:00–22:00",
            "sábado_receso60": "—",
            "sábado_receso30": "17:30–18:00",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente58",
            "selected": false,
            "lunes_horario": "16:00–22:00",
            "lunes_receso60": "—",
            "lunes_receso30": "18:00–18:30",
            "lunes_receso15": "—",
            "martes_horario": "16:00–22:00",
            "martes_receso60": "—",
            "martes_receso30": "19:30–20:00",
            "martes_receso15": "—",
            "miércoles_horario": "16:00–22:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "18:30–19:00",
            "miércoles_receso15": "—",
            "jueves_horario": "16:00–22:00",
            "jueves_receso60": "—",
            "jueves_receso30": "18:30–19:00",
            "jueves_receso15": "—",
            "viernes_horario": "16:00–22:00",
            "viernes_receso60": "—",
            "viernes_receso30": "17:30–18:00",
            "viernes_receso15": "—",
            "sábado_horario": "16:00–22:00",
            "sábado_receso60": "—",
            "sábado_receso30": "18:30–19:00",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente59",
            "selected": false,
            "lunes_horario": "16:00–22:00",
            "lunes_receso60": "—",
            "lunes_receso30": "17:30–18:00",
            "lunes_receso15": "—",
            "martes_horario": "16:00–22:00",
            "martes_receso60": "—",
            "martes_receso30": "18:30–19:00",
            "martes_receso15": "—",
            "miércoles_horario": "16:00–22:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "17:30–18:00",
            "miércoles_receso15": "—",
            "jueves_horario": "16:00–22:00",
            "jueves_receso60": "—",
            "jueves_receso30": "19:00–19:30",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "16:00–22:00",
            "sábado_receso60": "—",
            "sábado_receso30": "17:30–18:00",
            "sábado_receso15": "—",
            "domingo_horario": "16:00–22:00",
            "domingo_receso60": "—",
            "domingo_receso30": "19:30–20:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente60",
            "selected": false,
            "lunes_horario": "16:00–22:00",
            "lunes_receso60": "—",
            "lunes_receso30": "18:00–18:30",
            "lunes_receso15": "—",
            "martes_horario": "16:00–22:00",
            "martes_receso60": "—",
            "martes_receso30": "17:30–18:00",
            "martes_receso15": "—",
            "miércoles_horario": "DS",
            "miércoles_receso60": "DS",
            "miércoles_receso30": "DS",
            "miércoles_receso15": "DS",
            "jueves_horario": "16:00–22:00",
            "jueves_receso60": "—",
            "jueves_receso30": "19:30–20:00",
            "jueves_receso15": "—",
            "viernes_horario": "16:00–22:00",
            "viernes_receso60": "—",
            "viernes_receso30": "19:00–19:30",
            "viernes_receso15": "—",
            "sábado_horario": "16:00–22:00",
            "sábado_receso60": "—",
            "sábado_receso30": "17:30–18:00",
            "sábado_receso15": "—",
            "domingo_horario": "16:00–22:00",
            "domingo_receso60": "—",
            "domingo_receso30": "18:30–19:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente61",
            "selected": false,
            "lunes_horario": "16:00–22:00",
            "lunes_receso60": "—",
            "lunes_receso30": "18:30–19:00",
            "lunes_receso15": "—",
            "martes_horario": "DS",
            "martes_receso60": "DS",
            "martes_receso30": "DS",
            "martes_receso15": "DS",
            "miércoles_horario": "16:00–22:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "18:00–18:30",
            "miércoles_receso15": "—",
            "jueves_horario": "16:00–22:00",
            "jueves_receso60": "—",
            "jueves_receso30": "17:30–18:00",
            "jueves_receso15": "—",
            "viernes_horario": "16:00–22:00",
            "viernes_receso60": "—",
            "viernes_receso30": "17:30–18:00",
            "viernes_receso15": "—",
            "sábado_horario": "16:00–22:00",
            "sábado_receso60": "—",
            "sábado_receso30": "18:00–18:30",
            "sábado_receso15": "—",
            "domingo_horario": "16:00–22:00",
            "domingo_receso60": "—",
            "domingo_receso30": "18:30–19:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente62",
            "selected": false,
            "lunes_horario": "17:00–23:00",
            "lunes_receso60": "—",
            "lunes_receso30": "19:30–20:00",
            "lunes_receso15": "—",
            "martes_horario": "17:00–23:00",
            "martes_receso60": "—",
            "martes_receso30": "20:30–21:00",
            "martes_receso15": "—",
            "miércoles_horario": "17:00–23:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "19:30–20:00",
            "miércoles_receso15": "—",
            "jueves_horario": "17:00–23:00",
            "jueves_receso60": "—",
            "jueves_receso30": "18:30–19:00",
            "jueves_receso15": "—",
            "viernes_horario": "17:00–23:00",
            "viernes_receso60": "—",
            "viernes_receso30": "19:30–20:00",
            "viernes_receso15": "—",
            "sábado_horario": "17:00–23:00",
            "sábado_receso60": "—",
            "sábado_receso30": "19:30–20:00",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente63",
            "selected": false,
            "lunes_horario": "17:00–23:00",
            "lunes_receso60": "—",
            "lunes_receso30": "20:00–20:30",
            "lunes_receso15": "—",
            "martes_horario": "17:00–23:00",
            "martes_receso60": "—",
            "martes_receso30": "18:30–19:00",
            "martes_receso15": "—",
            "miércoles_horario": "17:00–23:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "20:30–21:00",
            "miércoles_receso15": "—",
            "jueves_horario": "17:00–23:00",
            "jueves_receso60": "—",
            "jueves_receso30": "20:30–21:00",
            "jueves_receso15": "—",
            "viernes_horario": "17:00–23:00",
            "viernes_receso60": "—",
            "viernes_receso30": "20:30–21:00",
            "viernes_receso15": "—",
            "sábado_horario": "17:00–23:00",
            "sábado_receso60": "—",
            "sábado_receso30": "19:30–20:00",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente64",
            "selected": false,
            "lunes_horario": "17:00–23:00",
            "lunes_receso60": "—",
            "lunes_receso30": "19:30–20:00",
            "lunes_receso15": "—",
            "martes_horario": "17:00–23:00",
            "martes_receso60": "—",
            "martes_receso30": "19:30–20:00",
            "martes_receso15": "—",
            "miércoles_horario": "17:00–23:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "18:30–19:00",
            "miércoles_receso15": "—",
            "jueves_horario": "17:00–23:00",
            "jueves_receso60": "—",
            "jueves_receso30": "20:30–21:00",
            "jueves_receso15": "—",
            "viernes_horario": "17:00–23:00",
            "viernes_receso60": "—",
            "viernes_receso30": "20:30–21:00",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "17:00–23:00",
            "domingo_receso60": "—",
            "domingo_receso30": "20:30–21:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente65",
            "selected": false,
            "lunes_horario": "17:00–23:00",
            "lunes_receso60": "—",
            "lunes_receso30": "19:00–19:30",
            "lunes_receso15": "—",
            "martes_horario": "17:00–23:00",
            "martes_receso60": "—",
            "martes_receso30": "19:00–19:30",
            "martes_receso15": "—",
            "miércoles_horario": "17:00–23:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "19:30–20:00",
            "miércoles_receso15": "—",
            "jueves_horario": "17:00–23:00",
            "jueves_receso60": "—",
            "jueves_receso30": "19:00–19:30",
            "jueves_receso15": "—",
            "viernes_horario": "17:00–23:00",
            "viernes_receso60": "—",
            "viernes_receso30": "19:30–20:00",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "17:00–23:00",
            "domingo_receso60": "—",
            "domingo_receso30": "20:30–21:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente66",
            "selected": false,
            "lunes_horario": "17:00–23:00",
            "lunes_receso60": "—",
            "lunes_receso30": "20:30–21:00",
            "lunes_receso15": "—",
            "martes_horario": "17:00–23:00",
            "martes_receso60": "—",
            "martes_receso30": "18:30–19:00",
            "martes_receso15": "—",
            "miércoles_horario": "17:00–23:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "19:30–20:00",
            "miércoles_receso15": "—",
            "jueves_horario": "17:00–23:00",
            "jueves_receso60": "—",
            "jueves_receso30": "20:30–21:00",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "17:00–23:00",
            "sábado_receso60": "—",
            "sábado_receso30": "20:30–21:00",
            "sábado_receso15": "—",
            "domingo_horario": "17:00–23:00",
            "domingo_receso60": "—",
            "domingo_receso30": "18:30–19:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente67",
            "selected": false,
            "lunes_horario": "17:00–23:00",
            "lunes_receso60": "—",
            "lunes_receso30": "19:00–19:30",
            "lunes_receso15": "—",
            "martes_horario": "17:00–23:00",
            "martes_receso60": "—",
            "martes_receso30": "19:30–20:00",
            "martes_receso15": "—",
            "miércoles_horario": "17:00–23:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "18:30–19:00",
            "miércoles_receso15": "—",
            "jueves_horario": "DS",
            "jueves_receso60": "DS",
            "jueves_receso30": "DS",
            "jueves_receso15": "DS",
            "viernes_horario": "17:00–23:00",
            "viernes_receso60": "—",
            "viernes_receso30": "18:30–19:00",
            "viernes_receso15": "—",
            "sábado_horario": "17:00–23:00",
            "sábado_receso60": "—",
            "sábado_receso30": "18:30–19:00",
            "sábado_receso15": "—",
            "domingo_horario": "17:00–23:00",
            "domingo_receso60": "—",
            "domingo_receso30": "19:00–19:30",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente68",
            "selected": false,
            "lunes_horario": "17:00–23:00",
            "lunes_receso60": "—",
            "lunes_receso30": "19:30–20:00",
            "lunes_receso15": "—",
            "martes_horario": "17:00–23:00",
            "martes_receso60": "—",
            "martes_receso30": "19:30–20:00",
            "martes_receso15": "—",
            "miércoles_horario": "17:00–23:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "20:00–20:30",
            "miércoles_receso15": "—",
            "jueves_horario": "17:00–23:00",
            "jueves_receso60": "—",
            "jueves_receso30": "19:30–20:00",
            "jueves_receso15": "—",
            "viernes_horario": "17:00–23:00",
            "viernes_receso60": "—",
            "viernes_receso30": "20:00–20:30",
            "viernes_receso15": "—",
            "sábado_horario": "17:00–23:00",
            "sábado_receso60": "—",
            "sábado_receso30": "19:00–19:30",
            "sábado_receso15": "—",
            "domingo_horario": "DS",
            "domingo_receso60": "DS",
            "domingo_receso30": "DS",
            "domingo_receso15": "DS"
        },
        {
            "agente": "Agente69",
            "selected": false,
            "lunes_horario": "17:00–23:00",
            "lunes_receso60": "—",
            "lunes_receso30": "20:30–21:00",
            "lunes_receso15": "—",
            "martes_horario": "17:00–23:00",
            "martes_receso60": "—",
            "martes_receso30": "20:30–21:00",
            "martes_receso15": "—",
            "miércoles_horario": "17:00–23:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "20:30–21:00",
            "miércoles_receso15": "—",
            "jueves_horario": "17:00–23:00",
            "jueves_receso60": "—",
            "jueves_receso30": "20:30–21:00",
            "jueves_receso15": "—",
            "viernes_horario": "17:00–23:00",
            "viernes_receso60": "—",
            "viernes_receso30": "20:30–21:00",
            "viernes_receso15": "—",
            "sábado_horario": "DS",
            "sábado_receso60": "DS",
            "sábado_receso30": "DS",
            "sábado_receso15": "DS",
            "domingo_horario": "17:00–23:00",
            "domingo_receso60": "—",
            "domingo_receso30": "20:30–21:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente70",
            "selected": false,
            "lunes_horario": "17:00–23:00",
            "lunes_receso60": "—",
            "lunes_receso30": "19:30–20:00",
            "lunes_receso15": "—",
            "martes_horario": "17:00–23:00",
            "martes_receso60": "—",
            "martes_receso30": "19:30–20:00",
            "martes_receso15": "—",
            "miércoles_horario": "17:00–23:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "20:30–21:00",
            "miércoles_receso15": "—",
            "jueves_horario": "17:00–23:00",
            "jueves_receso60": "—",
            "jueves_receso30": "20:30–21:00",
            "jueves_receso15": "—",
            "viernes_horario": "DS",
            "viernes_receso60": "DS",
            "viernes_receso30": "DS",
            "viernes_receso15": "DS",
            "sábado_horario": "17:00–23:00",
            "sábado_receso60": "—",
            "sábado_receso30": "20:30–21:00",
            "sábado_receso15": "—",
            "domingo_horario": "17:00–23:00",
            "domingo_receso60": "—",
            "domingo_receso30": "19:30–20:00",
            "domingo_receso15": "—"
        },
        {
            "agente": "Agente71",
            "selected": false,
            "lunes_horario": "17:00–23:00",
            "lunes_receso60": "—",
            "lunes_receso30": "20:30–21:00",
            "lunes_receso15": "—",
            "martes_horario": "17:00–23:00",
            "martes_receso60": "—",
            "martes_receso30": "20:30–21:00",
            "martes_receso15": "—",
            "miércoles_horario": "17:00–23:00",
            "miércoles_receso60": "—",
            "miércoles_receso30": "19:00–19:30",
            "miércoles_receso15": "—",
            "jueves_horario": "DS",
            "jueves_receso60": "DS",
            "jueves_receso30": "DS",
            "jueves_receso15": "DS",
            "viernes_horario": "17:00–23:00",
            "viernes_receso60": "—",
            "viernes_receso30": "19:30–20:00",
            "viernes_receso15": "—",
            "sábado_horario": "17:00–23:00",
            "sábado_receso60": "—",
            "sábado_receso30": "19:30–20:00",
            "sábado_receso15": "—",
            "domingo_horario": "17:00–23:00",
            "domingo_receso60": "—",
            "domingo_receso30": "19:30–20:00",
            "domingo_receso15": "—"
        }
    ],
    "diasUnicosResumen": [
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
        "domingo"
    ]
}